export const translations = {
  ar: {
    // ── Brand & Navigation ──
    "brand.name": "تيري لاند",
    "brand.tagline": "منسوجات فاخرة",
    "nav.home": "الرئيسية", 
    "nav.about": "من نحن",
    "nav.shop": "المتجر",
    "nav.collections": "المجموعات",
    "nav.allCollections": "جميع المجموعات",
    "nav.blog": "المدونة",
    "nav.contact": "اتصل بنا",
    "nav.account": "حسابي",
    "nav.signIn": "تسجيل الدخول",
    "nav.admin": "لوحة التحكم",
    "nav.cart": "سلة التسوق",
    "nav.language": "English",
    "nav.languageAria": "التبديل إلى اللغة الإنجليزية",
    "nav.theme": "المظهر",
    "nav.themeAria": "تبديل المظهر بين الداكن والفاتح",
    "nav.themeLight": "الوضع الفاتح",
    "nav.themeDark": "الوضع الداكن",
    "nav.themeSystem": "مظهر النظام",

    // ── Common & Actions ──
    "action.addToCart": "أضف إلى السلة",
    "action.adding": "جاري الإضافة…",
    "action.added": "تمت الإضافة للسلة ✓",
    "action.viewProduct": "عرض المنتج",
    "action.viewCart": "عرض السلة",
    "action.shopNow": "تسوق الآن",
    "action.explore": "استكشف المجموعة",
    "action.checkout": "إتمام الشراء",
    "action.continueShopping": "متابعة التسوق",
    "action.save": "حفظ",
    "action.cancel": "إلغاء",
    "action.delete": "حذف",
    "action.edit": "تعديل",
    "action.filter": "تصفية",
    "action.sortBy": "ترتيب حسب:",
    "action.subscribe": "اشتراك",
    "action.back": "رجوع",
    "action.backToShop": "العودة للمتجر",

    // ── Product Detail & Cards ──
    "product.color": "اللون",
    "product.size": "المقاس",
    "product.quantity": "الكمية",
    "product.price": "السعر",
    "product.selectColorAndSize": "يرجى اختيار المقاس واللون.",
    "product.luxuryCollection": "مجموعة فاخرة",
    "product.freeDeliveryNote": "شحن مجاني للطلبات أكثر من {amount}",
    "product.freeDelivery": "توصيل سريع ومجاني",
    "product.easyReturns": "إرجاع واستبدال مرن",
    "product.securePayment": "دفع آمن ومضمون",
    "product.guestNotice": "متاح الشراء كزائر ·",
    "product.signInLink": "سجل دخولك",
    "product.saveBagNote": "لحفظ سلتك ومتابعة طلباتك.",
    "product.notFound": "هذا المنتج غير متوفر حالياً.",
    "product.outOfStock": "نفدت الكمية",
    "product.inStock": "متوفر في المخزون",
    "product.onlyLeft": "متبقي {count} قطع فقط!",
    "product.selectCombinationOutOfStock": "هذا المقاس واللون غير متوفرين حالياً، يرجى اختيار تشكيلة أخرى.",
    "product.zoomIn": "تكبير",
    "product.zoomOut": "تصغير",
    "product.resetZoom": "إعادة ضبط",
    "product.closeInspector": "إغلاق المعاينة",
    "product.imageCount": "صورة {current} من {total}",
    "product.recommendedEyebrow": "تنسيق متناغم • تشكيلات مختارة",
    "product.recommendedTitle": "قد يعجبك أيضاً",
    "product.recommendedSubtitle": "قطع فاخرة منتقاة بعناية تكمل إطلالتك اليومية من قطن تيري لاند",
    "product.swipeHint": "اسحب أفقياً لاستكشاف المزيد",
    "product.sameCollectionBadge": "نفس التشكيلة",
    "product.fromCollectionBadge": "تشكيلة {name}",

    // ── Features & USPs ──
    "feature.premium": "جودة فائقة",
    "feature.premiumSub": "أفضل الخامات المختارة بعناية",
    "feature.ultraSoft": "نعومة فائقة",
    "feature.ultraSoftSub": "لطيف وآمن على بشرتك",
    "feature.timeless": "تصميم أنيق",
    "feature.timelessSub": "فخامة تدوم لسنوات",
    "feature.sustainable": "صديق للبيئة",
    "feature.sustainableSub": "إنتاج مستدام وصحي",

    // ── Home Page ──
    "home.metaTitle": "تيري لاند | برانص حمام وفوط وبشاكير ومفروشات عرائس فاخرة — قطن ومايكروفايبر",
    "home.heroEyebrow": "تيري لاند · أفخم المنسوجات وأفضل الخامات",
    "home.heroTitleLine1": "نعومة وراحة",
    "home.heroTitleLine2": "لمسة أناقة",
    "home.heroSub": "برانص حمام فاخرة، فوط وبشاكير فندقية، ومفروشات وتجهيزات عرائس راقية بخامات مبتكرة من القطن والمايكروفايبر وخامة الوجهين.",
    "home.scroll": "مرر للأسفل",
    "home.curatedLabel": "مختارة لأجلك",
    "home.curatedTitle": "تشكيلاتنا الفاخرة",
    "home.curatedDesc": "اكتشف مجموعاتنا المختارة بعناية لتمنح يومك لمسة من الراحة والأناقة الخالدة.",
    "home.bestsellingLabel": "الأكثر طلباً",
    "home.bestsellingTitle": "أفضل البرانص، الفوط، وأطقم العرائس مبيعاً",
    "home.viewAllProducts": "عرض جميع المنتجات",
    "home.craftedLabel": "التزامنا بالجودة",
    "home.craftedTitle": "صُنعت بعناية واستدامة",
    "home.craftedText1": "كل قطعة في تيري لاند تُنسج بعناية فائقة. نعتمد على مزيج متطور من خيوط المايكروفايبر فائقة النعومة والقطن الطبيعي لضمان امتصاص سريع، وخفة مريحة، ونعومة تدوم لسنوات.",
    "home.craftedText2": "يجمع حرفيونا بين مهارات النسيج العريقة وأحدث تقنيات الإنتاج لنحول روتينك اليومي إلى تجربة فندقية فاخرة في راحة منزلك.",
    "home.ourStory": "قصتنا",
    "home.statYears": "سنوات من التميز",
    "home.statCustomers": "عميل سعيد",
    "home.statCotton": "جودة مضمونة",
    "home.statRating": "متوسط التقييم",
    "home.collBaby": "مجموعة المواليد والأطفال",
    "home.collBabySub": "ناعمة · آمنة · فائقة الرقة",
    "home.collTowels": "مجموعة المناشف",
    "home.collTowelsSub": "امتصاص فائق · نعومة تدوم",
    "home.collRobes": "مجموعة الأرواب الفاخرة",
    "home.collRobesSub": "استرخاء وأناقة يومية",

    // ── Shop Page ──
    "shop.metaTitle": "المتجر | برانص حمام وفوط وبشاكير ومفروشات عرائس — تيري لاند",
    "shop.title": "المتجر",
    "shop.subtitle": "منسوجات فاخرة صنعت بعناية فائقة لتمنحك الراحة اليومية",
    "shop.all": "جميع التشكيلات",
    "shop.results": "عرض {count} من النتائج",
    "shop.showing": "عرض {count} من أصل {total} منتج",
    "shop.noProducts": "لا توجد منتجات متطابقة في هذا القسم حالياً.",
    "shop.sort.collection": "ترتيب المجموعات (الأقسام)",
    "shop.sort.bestselling": "الأكثر مبيعاً",
    "shop.sort.newest": "الأحدث",
    "shop.sort.priceAsc": "السعر: من الأقل للأعلى",
    "shop.sort.priceDesc": "السعر: من الأعلى للأقل",
    "product.bestSeller": "الأكثر مبيعاً",
    "shop.luxuryBannerEyebrow": "منذ 1956 • حكاية إتقان",
    "shop.luxuryBannerTitle": "وراء كل قطعة قصة... إرث من الخبرة وشغف النسيج",
    "shop.luxuryBannerSub": "عقود من الخبرة، ننسج بها الفخامة والراحة في كل تفصيل.",
    "shop.luxuryBannerCta": "اكتشف قصة تيري لاند",
    "shop.luxuryBannerTag1": "خامات قطن ومايكروفايبر فائقة النعومة",
    "shop.luxuryBannerTag2": "حياكة وبرية فندقية متقنة",
    "shop.luxuryBannerTag3": "عقود من الخبرة والريادة",
    "shop.filterDrawerTitle": "تصفية المنتجات",
    "shop.categories": "التشكيلات والفئات",
    "shop.priceRange": "نطاق السعر",
    "shop.minPrice": "الحد الأدنى",
    "shop.maxPrice": "الحد الأقصى",
    "shop.resetFilters": "إعادة ضبط",
    "shop.applyFilters": "تطبيق الفلاتر",
    "shop.activeFilters": "الفلاتر النشطة:",
    "shop.clearAll": "مسح الكل",
    "shop.noProductsTitle": "لم نتمكن من العثور على أي منتجات",
    "shop.noProductsHint": "جرب تعديل كلمات البحث أو مسح بعض الفلاتر المحددة لعرض المنتجات.",
    "shop.egp": "ج.م",
    "shop.priceUnder500": "أقل من ٥٠٠ ج.م",
    "shop.price500to1500": "٥٠٠ - ١,٥٠٠ ج.م",
    "shop.priceOver1500": "أكثر من ١,٥٠٠ ج.م",
    "shop.searchPlaceholder": "ابحث عن المنتجات بالاسم، الخامة، أو الموديل…",
    "shop.collectionTag": "تشكيلة حصرية",

    // ── Cart & Checkout ──
    "cart.title": "سلة التسوق",
    "cart.empty": "سلة التسوق فارغة حالياً.",
    "cart.emptyDesc": "استكشف تشكيلاتنا الفاخرة وأضف لمسة راقية إلى يومك.",
    "cart.product": "المنتج",
    "cart.unitPrice": "سعر القطعة",
    "cart.total": "الإجمالي",
    "cart.subtotal": "المجموع الفرعي",
    "cart.shipping": "تكلفة الشحن",
    "cart.shippingCalc": "تحسب عند إتمام الطلب",
    "cart.orderSummary": "ملخص الطلب",
    "cart.proceedCheckout": "متابعة إتمام الطلب",
    "cart.remove": "إزالة",
    "cart.stepBag": "سلة التسوق",
    "cart.stepCheckout": "إتمام الطلب",
    "cart.stepDone": "تأكيد الطلب",
    "cart.freeShippingUnlocked": "🎉 تهانينا! طلبك مؤهل للشحن المجاني",
    "cart.freeShippingRemaining": "أضف {amount} إضافية للحصول على شحن مجاني!",
    "cart.continueShopping": "متابعة التسوق",
    "cart.secureCheckout": "دفع إلكتروني آمن ومشفر 100%",
    "cart.fastDelivery": "شحن وتوصيل سريع لباب منزلك",
    "cart.easyReturns": "استبدال واسترجاع سهل وسلس",
    "cart.explorePrompt": "تصفح أشهر التشكيلات:",
    "cart.packageLimitExceeded": "حجم السلة يتجاوز الحد الأقصى المسموح به للشحن. يرجى تقليل كمية المنتجات.",
    "cart.packageLimitExceededBannerTitle": "تجاوز الحد الأقصى لحجم الشحن",
    "cart.packageLimitExceededBannerDesc": "حجم طلبك يتجاوز سعة صندوق الشحن المسموح بها من شركة الشحن (الحد الأقصى {maxVolume} سم³). يرجى تقليل كميات العناصر أو إزالة بعضها للمتابعة إلى إتمام الطلب.",
    "cart.packageLimitItemCannotAdd": "لا يمكن إضافة هذا المنتج: حجم السلة سيتجاوز الحد الأقصى المسموح به للشحن. يرجى تقليل كميات العناصر الأخرى أولاً.",
    "cart.packageLimitItemCannotIncrease": "لا يمكن زيادة الكمية: ستتجاوز السلة الحد الأقصى المسموح به للشحن.",
    "cart.mustReduceItemsToCheckout": "يرجى تقليل كمية المنتجات في السلة للمتابعة إلى الدفع لأنها تتجاوز سعة الشحن المسموح بها.",
    "cart.packageCapacity": "سعة الشحن المستخدمة",
    "cart.packageLimitReached": "تم الوصول لأقصى حجم شحن مسموح",

    // ── Coupon / Promo ──
    "coupon.havePromo": "هل لديك كود خصم؟",
    "coupon.placeholder": "أدخل كود الخصم (مثال: SUMMER20)",
    "coupon.apply": "تطبيق",
    "coupon.applying": "جاري التحقق…",
    "coupon.remove": "إزالة الكود",
    "coupon.discount": "الخصم",
    "coupon.saved": "وفرت {amount}",
    "coupon.applied": "تم تطبيق كود الخصم ({code}) بنجاح!",
    "coupon.enterCode": "يرجى إدخال كود الخصم.",

    // ── Checkout ──
    "checkout.title": "إتمام الشراء",
    "checkout.subtitle": "أدخل تفاصيل التوصيل والدفع لتأكيد طلبك",
    "checkout.shippingAddress": "عنوان الشحن والتوصيل",
    "checkout.billingAddress": "عنوان الفاتورة",
    "checkout.billingSameAsShipping": "عنوان الفاتورة يطابق عنوان الشحن",
    "checkout.paymentMethod": "طريقة الدفع",
    "checkout.cod": "الدفع عند الاستلام (COD)",
    "checkout.codSub": "ادفع نقداً عند استلام طلبك من مندوب التوصيل",
    "checkout.card": "بطاقة بنكية (Paymob)",
    "checkout.cardSub": "دفع إلكتروني فوري ومشفر عبر Paymob",
    "checkout.wallet": "محفظة إلكترونية",
    "checkout.walletSub": "فودافون كاش، أورنج، والمحافظ الذكية",
    "checkout.placeOrder": "تأكيد الطلب الآن",
    "checkout.differentAddress": "اختيار عنوان آخر",
    "checkout.addNewAddress": "إضافة عنوان جديد",
    "checkout.noAddressPrompt": "لم تقم بإضافة أي عناوين مسجلة بعد.",
    "checkout.addShippingAddress": "إضافة عنوان شحن",
    "checkout.addBillingAddress": "إضافة عنوان فاتورة",
    "checkout.selectedBadge": "العنوان المحدد للتوصيل",
    "checkout.defaultBadge": "افتراضي",
    "checkout.modalSelectTitle": "اختر عنوان التوصيل",
    "checkout.modalAddTitle": "إضافة عنوان جديد",
    "checkout.country": "الدولة",
    "checkout.city": "المدينة",
    "checkout.selectCity": "اختر المدينة",
    "checkout.district": "المنطقة / الحي",
    "checkout.selectDistrict": "اختر المنطقة أو ابحث عنها",
    "checkout.streetDesc": "العنوان بالتفصيل (الشارع / رقم المبنى)",
    "checkout.streetPlaceholder": "مثال: شارع النصر، مبنى 14، شقة 5",
    "checkout.phone": "رقم الهاتف للتواصل",
    "checkout.phonePlaceholder": "رقم الهاتف المحمول",
    "checkout.setDefault": "تعيين كعنوان افتراضي رئيسي",
    "checkout.saveAddress": "حفظ العنوان",
    "checkout.savingAddress": "جاري الحفظ…",
    "checkout.orderSummary": "ملخص الطلب",
    "checkout.trustSecure": "دفع آمن ومشفر 100%",
    "checkout.trustDelivery": "شحن وتوصيل لباب المنزل عبر بوسطة",
    "checkout.trustReturns": "إمكانية الاسترجاع خلال 14 يوماً",
    "checkout.missingShipping": "يرجى اختيار عنوان الشحن أولاً.",
    "checkout.missingBilling": "يرجى اختيار عنوان الفاتورة.",
    "checkout.emptyCart": "سلة التسوق فارغة حالياً.",
    "checkout.continueShopping": "العودة للتسوق",
    "checkout.backToCart": "العودة إلى السلة",
    "checkout.processing": "جاري معالجة الطلب…",
    "checkout.itemsInOrder": "المنتجات في الطلب",

    // ── Guest Checkout ──
    "guestCheckout.title": "شراء سريع كزائر",
    "guestCheckout.subtitle": "أدخل بيانات التواصل وعنوان التوصيل لإتمام طلبك سريعاً بدون إنشاء حساب",
    "guestCheckout.haveAccount": "لديك حساب بالفعل؟",
    "guestCheckout.signIn": "سجل دخولك هنا",
    "guestCheckout.contactInfo": "بيانات التواصل",
    "guestCheckout.contactSub": "سنرسل رابط تأكيد الطلب وتفاصيل تتبع الشحنة إلى هذا البريد الإلكتروني.",
    "guestCheckout.email": "البريد الإلكتروني",
    "guestCheckout.emailPlaceholder": "name@example.com",
    "guestCheckout.firstName": "الاسم الأول",
    "guestCheckout.firstNamePlaceholder": "الاسم الأول",
    "guestCheckout.lastName": "اسم العائلة",
    "guestCheckout.lastNamePlaceholder": "اسم العائلة",
    "guestCheckout.deliveryAddress": "عنوان التوصيل",
    "guestCheckout.country": "الدولة",
    "guestCheckout.egypt": "مصر (Egypt)",
    "guestCheckout.city": "المدينة",
    "guestCheckout.selectCity": "اختر المدينة",
    "guestCheckout.loadingCities": "جاري تحميل المدن…",
    "guestCheckout.district": "المنطقة / الحي",
    "guestCheckout.selectDistrict": "اختر المنطقة أو ابحث عنها",
    "guestCheckout.selectCityFirst": "اختر المدينة أولاً",
    "guestCheckout.loadingDistricts": "جاري تحميل المناطق…",
    "guestCheckout.streetDetails": "العنوان بالتفصيل (الشارع، رقم المبنى، والدور)",
    "guestCheckout.streetPlaceholder": "مثال: 14 شارع النصر، عمارة 4ب، الدور الثالث، شقة 12",
    "guestCheckout.minCharsNotice": "{count}/25 حرف كحد أدنى",
    "guestCheckout.streetHint": "يرجى كتابة تفاصيل واضحة ودقيقة لتمكين مندوب بوسطة من الوصول إليك بسهولة.",
    "guestCheckout.phone": "رقم الهاتف المحمول",
    "guestCheckout.phonePlaceholder": "رقم الهاتف المحمول",
    "guestCheckout.phoneHint": "يمكنك كتابة الرقم بصيغة 01022334455 أو 1022334455 للتواصل أثناء التوصيل.",
    "guestCheckout.paymentMethod": "طريقة الدفع",
    "guestCheckout.cod": "الدفع عند الاستلام (COD)",
    "guestCheckout.codSub": "ادفع نقداً عند استلام طلبك لباب المنزل عبر مندوب بوسطة",
    "guestCheckout.orderSummary": "ملخص الطلب",
    "guestCheckout.subtotal": "المجموع الفرعي",
    "guestCheckout.shipping": "الشحن (بوسطة)",
    "guestCheckout.calculating": "جاري الحساب…",
    "guestCheckout.freeShipping": "مجاناً",
    "guestCheckout.shippingUnavailable": "غير متاح",
    "guestCheckout.selectDistrictHint": "اختر المنطقة",
    "guestCheckout.calcPrompt": "حدد المدينة والحي أعلاه لحساب رسوم التوصيل بدقة.",
    "guestCheckout.totalDue": "الإجمالي المستحق",
    "guestCheckout.placeOrder": "تأكيد الطلب كزائر",
    "guestCheckout.placingOrder": "جاري إرسال الطلب…",
    "guestCheckout.backToCart": "العودة إلى السلة",
    "guestCheckout.trustShipping": "شحن سريع لجميع محافظات مصر عبر بوسطة",
    "guestCheckout.trustCod": "الدفع نقداً عند الاستلام لباب منزلك",
    "guestCheckout.trustReturns": "استرجاع واستبدال سهل خلال 14 يوماً",
    "guestCheckout.errVariants": "بعض المنتجات في السلة تنقصها معلومات الخيارات.",
    "guestCheckout.errDescMin": "يرجى كتابة عنوان مفصل لا يقل عن 25 حرفاً لضمان دقة التوصيل.",
    "guestCheckout.errPhone": "يرجى إدخال رقم محمول مصري صحيح (مثال: 010xxxxxxxx أو 10xxxxxxxx).",
    "guestCheckout.errCity": "يرجى اختيار المدينة والحي.",
    "guestCheckout.errFailed": "فشل إتمام الطلب كزائر، يرجى المحاولة مرة أخرى.",
    "guestCheckout.successToast": "تم تأكيد طلبك بنجاح!",
    "guestCheckout.successTitle": "تم تأكيد طلبك بنجاح!",
    "guestCheckout.orderConfirmedBadge": "تم تأكيد الطلب بنجاح",
    "guestCheckout.orderReference": "رقم الطلب:",
    "guestCheckout.copy": "نسخ",
    "guestCheckout.copied": "تم النسخ!",
    "guestCheckout.createPasswordSub": "تم تسجيل طلبك للبريد الإلكتروني {email}. أنشئ كلمة مرور الآن لمتابعة حسابك معنا وحفظ سجل طلباتك، أو يمكنك متابعة التسوق كزائر.",
    "guestCheckout.createPasswordLabel": "إنشاء كلمة المرور",
    "guestCheckout.createPasswordPlaceholder": "أدخل كلمة المرور الجديدة",
    "guestCheckout.confirmPasswordLabel": "تأكيد كلمة المرور",
    "guestCheckout.confirmPasswordPlaceholder": "أعد إدخال كلمة المرور",
    "guestCheckout.passwordRequirements": "شروط كلمة المرور",
    "guestCheckout.reqLength": "8 أحرف على الأقل",
    "guestCheckout.setPasswordAndJoin": "تعيين كلمة المرور والانضمام",
    "guestCheckout.activatingAccount": "جاري إنشاء الحساب...",
    "guestCheckout.or": "أو",
    "guestCheckout.continueAsGuest": "متابعة التسوق كزائر",
    "guestCheckout.accountCreatedTitle": "تم إنشاء حسابك وتفعيله بنجاح!",
    "guestCheckout.accountCreatedDesc": "مرحباً بك معنا! تم ربط طلبك بحسابك بشكل دائم وتم تسجيل دخولك. يمكنك الآن تتبع شحنتك والاطلاع على طلباتك في أي وقت.",
    "guestCheckout.accountCreatedToast": "تم إنشاء حسابك وتفعيله بنجاح!",
    "guestCheckout.viewMyOrders": "عرض ومتابعة طلباتي",
    "guestCheckout.errPasswordLength": "يجب أن تكون كلمة المرور بين 8 و 30 حرفاً.",
    "guestCheckout.errPasswordMatch": "كلمتا المرور غير متطابقتين.",
    "guestCheckout.continueShopping": "متابعة التسوق",
    "guestCheckout.backHome": "العودة للرئيسية",
    "guestCheckout.emptyTitle": "حقيبة التسوق فارغة",
    "guestCheckout.emptyDesc": "لا توجد منتجات في حقيبتك لإتمام الشراء كزائر.",
    "guestCheckout.exploreCollections": "استكشف التشكيلات",
    "guestCheckout.successHeroSub": "شكراً لك، {name}! تم استلام طلبك وتأكيده بنجاح. تم إرسال إيصال الشراء وتفاصيل الشحنة إلى {email}.",
    "guestCheckout.deliveryEstimate": "الموعد المتوقع للتوصيل",
    "guestCheckout.deliveryEstimateVal": "خلال 2 إلى 4 أيام عمل",
    "guestCheckout.courierName": "شحن سريع عبر بوسطة",
    "guestCheckout.courierLabel": "شركة الشحن",
    "guestCheckout.recipientLabel": "المستلم",
    "guestCheckout.phoneLabel": "رقم التواصل",
    "guestCheckout.paymentLabel": "طريقة الدفع",
    "guestCheckout.paymentCodVal": "الدفع عند الاستلام (COD)",
    "guestCheckout.paymentCardVal": "بطاقة دفع إلكترونية",
    "guestCheckout.timelineTitle": "مراحل تجهيز وتوصيل طلبك",
    "guestCheckout.step1Title": "تم تأكيد الطلب",
    "guestCheckout.step1Desc": "تم إرسال إيصال الطلب للبريد",
    "guestCheckout.step2Title": "تجهيز وتغليف المنتجات",
    "guestCheckout.step2Desc": "جاري تجهيز طلبك بعناية",
    "guestCheckout.step3Title": "في طريقها إليك",
    "guestCheckout.step3Desc": "مع مندوب شركة بوسطة",
    "guestCheckout.step4Title": "تم التوصيل بنجاح",
    "guestCheckout.step4Desc": "استلام آمن عند باب بيتك",
    "guestCheckout.trackAccountSectionBadge": "تسجيل الحساب الرسمي وتتبع الطلب",
    "guestCheckout.trackAccountTitle": "سجل حسابك معنا وتابع طلبك بأمان",
    "guestCheckout.trackAccountSub": "لحماية خصوصيتك وأمان حسابك، سنرسل إليك رابطاً آمناً لإنشاء كلمة المرور إلى بريدك الإلكتروني ({email}). بعد فتح الرابط في بريدك، ستتمكن من تعيين كلمة المرور وتفعيل حسابك رسمياً.",
    "guestCheckout.featureLiveTrack": "تتبع حالة الشحنة مباشرة مع بوسطة",
    "guestCheckout.featureInvoices": "الاطلاع على الفواتير وسجل المشتريات",
    "guestCheckout.featureQuickCheckout": "إتمام الطلبات المستقبلية بضغطة زر",
    "guestCheckout.sendSetupLinkBtn": "إرسال رابط إنشاء كلمة المرور إلى بريدي",
    "guestCheckout.sendingLink": "جاري إرسال الرابط...",
    "guestCheckout.linkSentBadge": "تم إرسال الرابط بنجاح",
    "guestCheckout.linkSentTitle": "تحقق من صندوق بريدك الإلكتروني",
    "guestCheckout.linkSentDesc": "أرسلنا رابطاً آمناً لإنشاء كلمة المرور إلى {email}. يُرجى فتح الرسالة والنقر على الرابط لتعيين كلمة المرور والانضمام إلينا.",
    "guestCheckout.linkSentSpamNotice": "ملاحظة: إذا لم تجد الرسالة في صندوق الوارد، يُرجى مراجعة مجلد الرسائل غير المرغوب فيها (Spam / Junk).",
    "guestCheckout.resendPrompt": "لم تصلك الرسالة بعد؟",
    "guestCheckout.resendBtn": "إعادة إرسال الرابط",
    "guestCheckout.resendCooldown": "إعادة الإرسال بعد ({seconds} ثانية)",
    "guestCheckout.fastSetupBadge": "أمان وحماية تامة • صلاحية الرابط 24 ساعة",
    "guestCheckout.cancelBtn": "إغلاق النموذج",
    "guestCheckout.resetFeatureTabTitle": "كيف يمكنك الوصول لحسابك وتتبع الطلب لاحقاً؟",
    "guestCheckout.resetFeatureTip1": "في حال لم ترغب بتعيين كلمة المرور الآن، يمكنك في أي وقت استخدام ميزة",
    "guestCheckout.resetFeatureTipHighlight": "«نسيت كلمة المرور / استعادة الحساب»",
    "guestCheckout.resetFeatureTip2": "في صفحة تسجيل الدخول، وإدخال بريدك {email} لتصلك رسالة تمكنك من الدخول لحسابك ومتابعة هذا الطلب بسهولة.",
    "guestCheckout.goToLogin": "الانتقال لصفحة تسجيل الدخول",
    "guestCheckout.trackMyOrderBtn": "تتبع طلبي في لوحة التحكم",
    "guestCheckout.accountCreatedSuccessBadge": "تم تفعيل الحساب وتسجيل الدخول بنجاح",
    "guestCheckout.accountActiveNotice": "أهلاً بك معنا! تم تفعيل حسابك بنجاح وتسجيل دخولك. يمكنك الآن الانتقال مباشرة لمتابعة تفاصيل وحالة شحنتك.",
    "guestCheckout.needHelp": "هل لديك أي استفسار أو ترغب في تعديل بيانات طلبك؟",
    "guestCheckout.contactSupport": "تواصل مع خدمة العملاء",

    // ── Verify Email & Order Confirmation ──
    "verifyEmail.verifyingTitle": "جاري التحقق",
    "verifyEmail.verifyingMessage": "جاري التحقق من بريدك الإلكتروني والطلب…",
    "verifyEmail.failedTitle": "فشل التحقق",
    "verifyEmail.errMissingParams": "رابط التحقق غير صالح. بيانات البريد أو رمز التفعيل مفقودة.",
    "verifyEmail.errFailedDefault": "تعذر التحقق من البريد الإلكتروني. قد يكون الرابط منتهي الصلاحية أو غير صالح.",
    "verifyEmail.returnHome": "العودة للرئيسية",
    "verifyEmail.orderConfirmedTitle": "تم تأكيد الطلب والبريد بنجاح",
    "verifyEmail.emailVerifiedTitle": "تم تفعيل البريد بنجاح",
    "verifyEmail.guestConfirmedMessage": "تم تأكيد طلبك وبريدك الإلكتروني بنجاح!",
    "verifyEmail.guestPreparingMessage": "تم تأكيد بريدك الإلكتروني وطلبك بنجاح! يقوم فريقنا الآن بتجهيز شحنتك للشحن والتوصيل.",
    "verifyEmail.standardSuccessMessage": "تم تأكيد وتفعيل بريدك الإلكتروني بنجاح! يمكنك الآن تسجيل الدخول إلى حسابك.",
    "verifyEmail.goToSignIn": "الانتقال لتسجيل الدخول",
    "verifyEmail.continueShopping": "متابعة التسوق",
    "verifyEmail.orderBadgeConfirmed": "تم تأكيد الطلب والبريد الإلكتروني",
    "verifyEmail.orderPlacedTitle": "تم تقديم طلبك بنجاح!",
    "verifyEmail.guestOrderIntro": "تم تأكيد طلبك للبريد الإلكتروني {email}. يمكنك الآن إنشاء كلمة مرور لحفظ سجل طلباتك ومتابعة شحنتك، أو متابعة التسوق كزائر.",
    "verifyEmail.createPasswordLabel": "إنشاء كلمة المرور",
    "verifyEmail.passwordPlaceholder": "أدخل كلمة المرور الجديدة",
    "verifyEmail.confirmPasswordLabel": "تأكيد كلمة المرور",
    "verifyEmail.confirmPasswordPlaceholder": "أعد إدخال كلمة المرور",
    "verifyEmail.showPassword": "إظهار كلمة المرور",
    "verifyEmail.hidePassword": "إخفاء كلمة المرور",
    "verifyEmail.requirementsTitle": "متطلبات كلمة المرور",
    "verifyEmail.reqLength": "على الأقل 8 أحرف (حتى 30 حرفاً)",
    "verifyEmail.errPasswordLength": "يجب أن تكون كلمة المرور بين 8 و 30 حرفاً.",
    "verifyEmail.errPasswordMatch": "كلمتا المرور غير متطابقتين.",
    "verifyEmail.errSetPasswordFailed": "تعذر تعيين كلمة المرور، قد يكون الرابط منتهياً.",
    "verifyEmail.activatingAccount": "جاري تفعيل الحساب…",
    "verifyEmail.setPasswordAndJoin": "تعيين كلمة المرور والانضمام",
    "verifyEmail.or": "أو",
    "verifyEmail.continueAsGuest": "متابعة التسوق كزائر",
    "verifyEmail.accountCreatedTitle": "تم إنشاء حسابك بنجاح!",
    "verifyEmail.accountCreatedIntro": "أهلاً بك معنا! تم ربط طلبك بحسابك الجديد بنجاح. يمكنك الآن تتبع حالة شحنتك والاطلاع على سجل طلباتك في أي وقت.",
    "verifyEmail.viewMyOrders": "عرض طلباتي",
    "verifyEmail.toastAccountCreated": "تم إنشاء وتفعيل حسابك بنجاح!",
    "verifyEmail.themeMode": "المظهر",
    "verifyEmail.themeLight": "فاتح",
    "verifyEmail.themeDark": "داكن",
    "verifyEmail.themeSystem": "تلقائي",
    "verifyEmail.language": "اللغة",

    // ── Reset Password ──
    "resetPassword.title": "إنشاء كلمة مرور جديدة",
    "resetPassword.subtitle": "أدخل كلمة المرور الجديدة لحسابك أدناه للمتابعة.",
    "resetPassword.passwordLabel": "كلمة المرور الجديدة",
    "resetPassword.passwordPlaceholder": "أدخل كلمة المرور الجديدة",
    "resetPassword.confirmPasswordLabel": "تأكيد كلمة المرور",
    "resetPassword.confirmPasswordPlaceholder": "أعد إدخال كلمة المرور الجديدة",
    "resetPassword.requirementsTitle": "متطلبات كلمة المرور",
    "resetPassword.reqLength": "على الأقل 8 أحرف (حتى 30 حرفاً)",
    "resetPassword.showPassword": "إظهار كلمة المرور",
    "resetPassword.hidePassword": "إخفاء كلمة المرور",
    "resetPassword.submitBtn": "تحديث كلمة المرور",
    "resetPassword.submitting": "جاري حفظ كلمة المرور…",
    "resetPassword.successTitle": "تم تحديث كلمة المرور بنجاح!",
    "resetPassword.successSubtitle": "تمت إعادة تعيين كلمة مرور حسابك بنجاح. يمكنك الآن تسجيل الدخول بحسابك ومتابعة طلباتك.",
    "resetPassword.proceedToSignIn": "الانتقال لتسجيل الدخول",
    "resetPassword.invalidTitle": "رابط غير صالح أو منتهي الصلاحية",
    "resetPassword.invalidSubtitle": "رابط استعادة كلمة المرور هذا غير صالح أو تنقصه بيانات التفعيل أو قد انتهت صلاحيته.",
    "resetPassword.requestNewLink": "طلب رابط استعادة جديد",
    "resetPassword.errPasswordMatch": "كلمتا المرور غير متطابقتين.",
    "resetPassword.errPasswordLength": "يجب أن تكون كلمة المرور بين 8 و 30 حرفاً.",
    "resetPassword.errFailedDefault": "تعذر تحديث كلمة المرور، قد يكون الرابط منتهي الصلاحية.",
    "resetPassword.toastSuccess": "تم تحديث كلمة المرور بنجاح!",

    // ── Forgot Password ──
    "forgotPassword.title": "استعادة كلمة المرور",
    "forgotPassword.subtitle": "أدخل بريدك الإلكتروني وسنرسل لك رابطاً لإعادة تعيين كلمة المرور الخاصة بحسابك.",
    "forgotPassword.emailLabel": "البريد الإلكتروني",
    "forgotPassword.emailPlaceholder": "name@example.com",
    "forgotPassword.submitBtn": "إرسال رابط الاستعادة",
    "forgotPassword.submitting": "جاري الإرسال…",
    "forgotPassword.backToSignIn": "العودة لتسجيل الدخول",
    "forgotPassword.checkEmailTitle": "تفقد بريدك الإلكتروني",
    "forgotPassword.checkEmailSubtitle": "لقد قمنا بإرسال رابط إعادة تعيين كلمة المرور إلى",
    "forgotPassword.returnToSignIn": "الانتقال لتسجيل الدخول",
    "forgotPassword.errFailedDefault": "تعذر إرسال رابط الاستعادة، يرجى المحاولة مرة أخرى.",
    "forgotPassword.toastSent": "تم إرسال رابط استعادة كلمة المرور إلى بريدك بنجاح!",

    // ── Authentication (Login) ──
    "auth.welcomeBack": "مرحباً بعودتك",
    "auth.signIn": "تسجيل الدخول",
    "auth.signInSub": "سجل دخولك لمتابعة طلباتك، إدارة عناوينك، والوصول لسلة مشترياتك المحفوظة.",
    "auth.email": "البريد الإلكتروني",
    "auth.emailPlaceholder": "name@example.com",
    "auth.password": "كلمة المرور",
    "auth.passwordPlaceholder": "••••••••",
    "auth.forgotPassword": "نسيت كلمة المرور؟",
    "auth.showPassword": "إظهار كلمة المرور",
    "auth.hidePassword": "إخفاء كلمة المرور",
    "auth.rememberMe": "تذكرني على هذا الجهاز",
    "auth.signingIn": "جاري تسجيل الدخول…",
    "auth.loginSuccess": "تم تسجيل الدخول بنجاح! مرحباً بعودتك.",
    "auth.loginError": "تعذر تسجيل الدخول، يرجى التحقق من صحة البريد الإلكتروني وكلمة المرور.",
    "auth.noAccount": "ليس لديك حساب بعد؟",
    "auth.createAccount": "إنشاء حساب جديد",
    "auth.checkoutNotice": "سجل دخولك للمتابعة لإتمام الطلب بحسابك، أو اختر الشراء كزائر:",
    "auth.continueAsGuest": "الشراء السريع كزائر",
    "auth.trustSecurity": "تسجيل دخول آمن ومشفر 100%",

    // ── Account & Subpages ──
    "account.sectionLabel": "حسابك الشخصي",
    "account.title": "إدارة تجربة تيري لاند",
    "account.welcome": "مرحباً بك مجدداً",
    "account.memberBadge": "عضو مميز",
    "account.profileTitle": "الملف الشخصي",
    "account.profileDesc": "تعديل الاسم والبيانات الشخصية ومعلومات الحساب.",
    "account.profileAction": "تعديل الملف الشخصي",
    "account.addressesTitle": "دفتر العناوين",
    "account.addressesDesc": "إدارة عناوين الشحن والتوصيل والفواتير.",
    "account.addressesAction": "إدارة العناوين",
    "account.ordersTitle": "الطلبات والمشتريات",
    "account.ordersDesc": "تتبع حالة الشحنات وسجل المشتريات السابقة.",
    "account.ordersAction": "عرض الطلبات",
    "account.supportTitle": "خدمة العملاء والكونسيرج",
    "account.supportDesc": "تواصل فوري مع فريق المساعدة عبر واتساب أو الهاتف.",
    "account.supportAction": "تواصل مع الكونسيرج",
    "account.signOutTitle": "تسجيل الخروج",
    "account.signOutDesc": "تسجيل الخروج من حسابك على هذا الجهاز بأمان.",
    "account.signOutAction": "تسجيل الخروج",

    // ── Profile Subpage ──
    "profile.back": "العودة للحساب",
    "profile.sectionLabel": "بيانات الحساب",
    "profile.title": "الملف الشخصي",
    "profile.verified": "حساب نشط وموثق",
    "profile.firstName": "الاسم الأول",
    "profile.firstNamePlaceholder": "أدخل الاسم الأول",
    "profile.lastName": "اسم العائلة",
    "profile.lastNamePlaceholder": "أدخل اسم العائلة",
    "profile.save": "حفظ التعديلات",
    "profile.saving": "جاري الحفظ…",
    "profile.success": "تم حفظ بيانات الملف الشخصي بنجاح.",
    "profile.error": "تعذر حفظ التعديلات، يرجى المحاولة مرة أخرى.",
    "profile.loadError": "تعذر تحميل بيانات الملف الشخصي.",

    // ── Addresses Subpage ──
    "addresses.back": "العودة للحساب",
    "addresses.sectionLabel": "الشحن والتوصيل",
    "addresses.title": "دفتر العناوين",
    "addresses.empty": "لا توجد عناوين محفوظة بعد. أضف عنوانك الأول لتسريع عملية الشراء.",
    "addresses.defaultBadge": "العنوان الافتراضي",
    "addresses.edit": "تعديل",
    "addresses.remove": "حذف",
    "addresses.add": "إضافة عنوان جديد",
    "addresses.newTitle": "إضافة عنوان جديد",
    "addresses.editTitle": "تعديل العنوان",
    "addresses.country": "الدولة",
    "addresses.egypt": "مصر",
    "addresses.city": "المحافظة / المدينة",
    "addresses.selectCity": "اختر المحافظة أو المدينة",
    "addresses.district": "المنطقة / الحي",
    "addresses.selectDistrict": "اختر المنطقة أو المركز",
    "addresses.description": "تفاصيل العنوان (الشارع، رقم المبنى، الشقة)",
    "addresses.descriptionPlaceholder": "مثال: شارع مصطفى النحاس، عمارة ١٢، شقة ٤",
    "addresses.phone": "رقم الهاتف للتواصل",
    "addresses.phonePlaceholder": "رقم الهاتف المحمول",
    "addresses.setDefault": "تعيين كعنوان افتراضي للتوصيل",
    "addresses.cancel": "إلغاء",
    "addresses.save": "حفظ العنوان",
    "addresses.saving": "جاري الحفظ…",
    "addresses.confirmDelete": "هل أنت متأكد من رغبتك في حذف هذا العنوان؟",
    "addresses.saveSuccess": "تم حفظ العنوان بنجاح.",
    "addresses.deleteSuccess": "تم حذف العنوان بنجاح.",
    "addresses.loadError": "تعذر تحميل العناوين.",

    // ── Orders Subpage ──
    "orders.back": "العودة للحساب",
    "orders.sectionLabel": "المشتريات",
    "orders.title": "طلباتك ومشترياتك",
    "orders.empty": "لم تقم بإجراء أي طلبات حتى الآن.",
    "orders.emptySub": "استكشف تشكيلاتنا الفاخرة من برانص الحمام، الفوط، البشاكير، ومفروشات العرايس.",
    "orders.startShopping": "ابدأ التسوق الآن",
    "orders.orderNum": "طلب رقم",
    "orders.previous": "السابق",
    "orders.next": "التالي",
    "orders.page": "صفحة {page}",
    "orders.loadError": "تعذر تحميل الطلبات.",

    // ── Order Detail Subpage ──
    "orderDetail.back": "جميع الطلبات",
    "orderDetail.sectionLabel": "تفاصيل الطلب",
    "orderDetail.orderNumber": "طلب رقم",
    "orderDetail.total": "الإجمالي",
    "orderDetail.shippingTitle": "عنوان الشحن والتوصيل",
    "orderDetail.billingTitle": "بيانات الفاتورة",
    "orderDetail.itemsTitle": "المنتجات المطلوبة",
    "orderDetail.buyAgain": "شراء مجدداً",
    "orderDetail.notFound": "لم يتم العثور على الطلب المطلوب.",
    "orderDetail.backToOrders": "العودة لقائمة الطلبات",
    "orderDetail.cancelOrder": "إلغاء الطلب",
    "orderDetail.cancelling": "جاري الإلغاء...",
    "orderDetail.cancelConfirmTitle": "تأكيد إلغاء الطلب",
    "orderDetail.cancelConfirmMsg": "هل أنت متأكد من رغبتك في إلغاء هذا الطلب؟ سيتم استرجاع المبلغ وإلغاء تجهيز الشحنة.",
    "orderDetail.cancelConfirmBtn": "نعم، إلغاء الطلب",
    "orderDetail.cancelKeepBtn": "التراجع والاحتفاظ بالطلب",
    "orderDetail.cancelSuccess": "تم إلغاء الطلب بنجاح.",
    "orderDetail.cancelError": "تعذر إلغاء الطلب، يرجى المحاولة لاحقاً.",
    "orderDetail.copyOrderNumber": "نسخ رقم الطلب",
    "orderDetail.copied": "تم النسخ!",
    "orderDetail.copiedToast": "تم نسخ رقم الطلب إلى الحافظة بنجاح!",
    "orderDetail.copyHint": "نسخ",
    "orderDetail.supportBtn": "مشكلة أو طلب إرجاع؟",
    "orderDetail.supportBtnTooltip": "تواصل معنا للمساعدة أو الإرجاع والاستبدال",
    "orderDetail.supportModalTitle": "هل تواجه مشكلة أو ترغب في إرجاع الطلب؟",
    "orderDetail.supportModalSubtitle": "يسعدنا دائماً خدمتك! وفقاً لسياسة الاسترجاع والاستبدال (خلال 14 يوماً)، يمكنك التواصل مع فريق الدعم لحل أي مشكلة أو تنسيق استرجاع الشحنة:",
    "orderDetail.supportWhatsappTitle": "محادثة فورية عبر واتساب",
    "orderDetail.supportWhatsappDesc": "أسرع وسيلة للتواصل المباشر مع فريق خدمة العملاء",
    "orderDetail.supportContactTitle": "نموذج التواصل (اتصل بنا)",
    "orderDetail.supportContactDesc": "إرسال رسالة رسمية لفريق خدمة العملاء",
    "orderDetail.supportCallTitle": "الاتصال الهاتفي المباشر",
    "orderDetail.supportCallDesc": "متاح يومياً من 10 ص حتى 10 م",
    "orderDetail.supportBannerTitle": "هل لديك أي استفسار أو ترغب في إرجاع هذا الطلب؟",
    "orderDetail.supportBannerDesc": "وفقاً لسياسة تيري لاند (14 يوماً للاسترجاع والاستبدال)، إذا واجهت أي مشكلة بالمنتجات أو مقاس غير مناسب، تواصل معنا مباشرة عبر واتساب أو صفحة اتصل بنا.",
    "orderDetail.whatsappAction": "محادثة واتساب",
    "orderDetail.contactAction": "صفحة اتصل بنا",
    "orderDetail.closeModal": "إغلاق",
    "orderDetail.bostaTrackingTitle": "تتبع الشحنات (بوسطة)",
    "orderDetail.bostaTrackingSubtitle": "يمكنك تتبع مسار شحنتك لحظة بلحظة مع شركة بوسطة باستخدام رقم التتبع أدناه:",
    "orderDetail.bostaTrackingNumber": "رقم التتبع (بوسطة)",
    "orderDetail.bostaCopyTracking": "نسخ رقم التتبع",
    "orderDetail.bostaCopiedTracking": "تم نسخ رقم التتبع!",
    "orderDetail.bostaTrackBtn": "تتبع على موقع بوسطة",
    "orderDetail.bostaAirwayBill": "عرض بوليصة الشحن",
    "orderDetail.bostaDispatched": "تاريخ الإنشاء",
    "orderDetail.bostaPreparing": "طلبك في مرحلة الشحن، جاري تجهيز الشحنة لتسليمها لمندوب بوسطة. سيظهر رقم التتبع هنا فور الاستلام.",
    "orderDetail.bostaMultipleNotice": "يتضمن هذا الطلب أكثر من شحنة (مثل شحنة التوصيل وشحنة الإرجاع أو الاستبدال). يمكنك تتبع كل شحنة على حدة.",

    // ── Footer ──
    "footer.tagline": "أرواب ومناشف فاخرة من أجود الخامات، صُنعت لتمنحك الراحة والأناقة اليومية.",
    "footer.colShop": "المتجر",
    "footer.colCompany": "عن تيري لاند",
    "footer.colSupport": "خدمة العملاء",
    "footer.colContact": "تواصل معنا",
    "footer.newsletterTitle": "اشترك بالنشرة البريدية ",
    "footer.newsletterSub": "اشترك لتصلك أحدث التشكيلات والعروض الحصرية أولاً بأول.",
    "footer.newsletterPlaceholder": "أدخل بريدك الإلكتروني",
    "footer.privacy": "سياسة الخصوصية",
    "footer.terms": "الشروط والأحكام",
    "footer.cookies": "ملفات تعريف الارتباط",
    "footer.rights": "© 2026 تيري لاند. جميع الحقوق محفوظة.",

    // ── About Page ──
    "about.metaTitle": "من نحن | تيري لاند - رواد صناعة البرانص والفوط ومفروشات العرايس منذ 1956",
    "about.breadcrumbHome": "الرئيسية",
    "about.breadcrumbCurrent": "من نحن",
    "about.heroEyebrow": "قصتنا وأصالتنا",
    "about.heroTitle": " شركه رائدة في مجال صناعة الوبريات",
    "about.heroSubtitle": "في تيري لاند، نؤمن بأن المنسوجات اليومية ليست مجرد أقمشة، بل تفاصيل تصنع فرقاً حقيقياً في جودة حياتك وتمنحك إحساساً دائماً بالسكينة والراحة الفائقة.",
    "about.storyBadge": "منذ 1956 • إرث عريق",
    "about.storyTitle": "إرث من الخبرة. رؤية للمستقبل.",
    "about.storyP1": "منذ 1956، تراكمت لدينا عقود من الخبرة في صناعة الوبريات، من فهم الخامات وتطويرها إلى إتقان تفاصيل التصنيع.",
    "about.storyP2": "واليوم، نأخذ هذه الخبرة إلى الأمام من خلال Terry Land؛ علامة جديدة تحمل إرثًا عريقًا، وتعيد تقديمه بروح عصرية تضع الابتكار والجودة والراحة في صميم كل منتج.",
    "about.storyValue1": "الابتكار",
    "about.storyValue1Desc": "رؤية عصرية تعيد ابتكار النسيج الوبري بتصاميم تواكب الحياة الحديثة.",
    "about.storyValue2": "الجودة العالية",
    "about.storyValue2Desc": "انتقاء دقيق لأجود الخامات ورقابة صارمة في كل درزة تدوم لسنوات.",
    "about.storyValue3": "الراحة الفائقة",
    "about.storyValue3Desc": "نعومة حريرية ولمسة هادئة تمنحك إحساساً دائماً بالسكينة والرفاهية.",
    "about.storyCardTag": "عراقة وتطور",
    "about.storyCardYear": "1956",
    "about.storyCardSubtitle": "عقود من الإتقان والريادة",
    "about.storyCardQuote": "خبرة عقود في صناعة الوبريات، نأخذها اليوم إلى الأمام لنعيد تعريف الفخامة والراحة اليومية بروح عصرية تليق بك.",
    "about.storyCardAuthor": "تيري لاند — Terry Land",
    "about.visionEyebrow": "طموحنا ومستقبلنا",
    "about.visionTitle": "رؤيتنا",
    "about.visionText": "أن نكون من العلامات الرائدة في صناعة الوبريات، من خلال تقديم منتجات تجمع بين الجودة العالية، التصميم المميز، والراحة، مع بناء علامة تجارية يثق بها عملاؤنا محليًا وعالميًا.",
    "about.goalsEyebrow": "خارطة التميز",
    "about.goalsTitle": "أهدافنا",
    "about.goalsSubtitle": "محاور استراتيجية تترجم رؤيتنا إلى واقع ملموس ومعايير راسخة في كل مرحلة من مراحل عملنا.",
    "about.goal1Title": "الجودة أولًا",
    "about.goal1Desc": "تقديم منتجات بمعايير جودة عالية، بدايةً من اختيار الخامات وحتى أدق تفاصيل التصنيع.",
    "about.goal2Title": "رضا العملاء",
    "about.goal2Desc": "فهم احتياجات عملائنا وتقديم منتجات وتجربة تتجاوز توقعاتهم.",
    "about.goal3Title": "الابتكار والتطوير",
    "about.goal3Desc": "تطوير تصاميم ومنتجات جديدة تواكب احتياجات السوق وتغيرات أذواق العملاء.",
    "about.goal4Title": "الاستدامة",
    "about.goal4Desc": "العمل على تحسين عمليات الإنتاج وتقليل الهدر والاستخدام المسؤول للموارد.",
    "about.goal5Title": "التوسع",
    "about.goal5Desc": "توسيع حضورنا في الأسواق المحلية والدولية وبناء شراكات طويلة الأمد.",
    "about.goal6Title": "بناء علامة موثوقة",
    "about.goal6Desc": "ترسيخ اسم الشركة كعلامة تتميز بالثقة والجودة والاهتمام بالتفاصيل.",
    "about.statsEyebrow": "أرقام وإنجازات",
    "about.statsTitle": "ثقة نصنعها بغرزة بعد غرزة",
    "about.stat1Value": "١٠٠%",
    "about.stat1Label": "جودة مضمونة",
    "about.stat2Value": "+٥٠,٠٠٠",
    "about.stat2Label": "عميل يثق في جودة منتجاتنا",
    "about.stat3Value": "+٢٥ عاماً",
    "about.stat3Label": "خبرة متوارثة في غزل الأقمشة",
    "about.stat4Value": "٤.٩ ★",
    "about.stat4Label": "متوسط تقييم رضا العملاء",
    "about.craftEyebrow": "تشريح الجودة",
    "about.craftTitle": "كيف نصنع الفرق في كل قطعة؟",
    "about.craftSubtitle": "اهتمام بأدق التفاصيل الفنية لتحقيق التوازن المثالي بين الكثافة، الامتصاص، والنعومة.",
    "about.craft1Title": "كثافة خيوط مدروسة (GSM)",
    "about.craft1Desc": "وزن مثالي يمنحك امتصاصاً فورياً ودفئاً مريحاً دون أن يكون ثقيلاً في الغسيل أو بطيئاً في الجفاف.",
    "about.craft2Title": "حلقات ممشطة ونقية",
    "about.craft2Desc": "تمشيط دقيق للألياف لإزالة الشوائب والخيوط القصيرة، مما يمنع تساقط الوبر ويمنح ملمساً قطيفياً ناعماً.",
    "about.craft3Title": "آمن ولطيف على جميع أنواع البشرة",
    "about.craft3Desc": "خالٍ من المواد الكيميائية الضارة ومناسب تماماً للبشرة الحساسة ولأولئك الذين يبحثون عن العناية الفائقة.",
    "about.ctaTitle": "استكشف خاماتنا الجديدة",
    "about.ctaSub": "استكشف تشكيلاتنا الفاخرة من أرواب الاستحمام ومجموعات المناشف، أو تواصل مع فريقنا لمساعدتك.",
    "about.ctaShop": "تصفح جميع المنتجات",
    "about.ctaContact": "تواصل معنا للاستفسارات",

    // ── Contact Page ──
    "contact.metaTitle": "اتصل بنا | خدمة عملاء وفخامة تيري لاند",
    "contact.breadcrumbHome": "الرئيسية",
    "contact.breadcrumbCurrent": "اتصل بنا",
    "contact.heroBadge": "خدمة عملاء راقية",
    "contact.heroTitle": "نحن هنا لخدمتك والرد على استفساراتك",
    "contact.heroSubtitle": "سواء كان لديك استفسار عن مقاسات الأرواب، تتبع شحنتك عبر بوسطة، أو ترغب في تنسيق هدايا وطلبات خاصة للشركات، فريقنا يسعد بالتواصل معك وتقديم الدعم الكامل.",
    "contact.whatsappTitle": "واتساب المباشر",
    "contact.whatsappDesc": "رد فوري وسريع على جميع الاستفسارات والمقاسات",
    "contact.whatsappAction": "تحدث معنا عبر واتساب",
    "contact.whatsappNumber": "+20 10 9992 1862",
    "contact.emailTitle": "البريد الإلكتروني",
    "contact.emailVal": "info@terryland.net",
    "contact.phoneTitle": "الهاتف المباشر",
    "contact.phoneVal": "+20 10 9992 1862",
    "contact.hoursTitle": "ساعات العمل الرسمية",
    "contact.hoursVal": "السبت – الخميس: ٩:٠٠ ص – ٩:٠٠ م",
    "contact.locationTitle": "المقر والإدارة العامة",
    "contact.locationVal": "شارع 400، العبور، محافظة القليوبية، مصر",
    "contact.faqPrompt": "هل تبحث عن إجابات سريعة بخصوص الشحن أو الاستبدال؟",
    "contact.faqLink": "تصفح الأسئلة الشائعة",
    "contact.formTitle": "أرسل لنا رسالة",
    "contact.formSubtitle": "املأ النموذج أدناه وسيقوم أحد ممثلي خدمة العملاء بالرد عليك خلال ساعات عمل قليلة.",
    "contact.subjectLabel": "نوع الاستفسار",
    "contact.subjOrder": "متابعة طلب",
    "contact.subjSize": "المقاسات والأقمشة",
    "contact.subjWholesale": "طلبات جملة وشركات",
    "contact.subjGeneral": "استفسار عام",
    "contact.nameLabel": "الاسم بالكامل",
    "contact.namePlaceholder": "مثال: أحمد محمد",
    "contact.emailLabel": "البريد الإلكتروني",
    "contact.emailPlaceholder": "name@example.com",
    "contact.phoneLabel": "رقم الهاتف المحمول (اختياري)",
    "contact.phonePlaceholder": "010 1234 5678",
    "contact.msgLabel": "نص الرسالة",
    "contact.msgPlaceholder": "اكتب تفاصيل استفسارك هنا، وسنسعد بمساعدتك...",
    "contact.charCount": "{count}/500 حرف",
    "contact.btnSend": "إرسال الرسالة",
    "contact.sending": "جاري الإرسال…",
    "contact.successTitle": "تم استلام رسالتك بنجاح!",
    "contact.successDesc": "شكراً لتواصلك مع تيري لاند. تم إرسال رسالتك إلى فريق خدمة العملاء وسنتواصل معك في أقرب وقت.",
    "contact.sendAnother": "إرسال رسالة أخرى",
    "contact.errName": "يرجى إدخال اسمك.",
    "contact.errEmail": "يرجى إدخال بريد إلكتروني صالح.",
    "contact.errMsg": "يرجى كتابة نص الرسالة (10 أحرف على الأقل).",
    "contact.toastSuccess": "تم إرسال رسالتك بنجاح! سنتواصل معك قريباً.",

    // ── FAQ Page ──
    "faq.metaTitle": "الأسئلة الشائعة | خامات المايكروفايبر والقطن ومفروشات العرايس — تيري لاند",
    "faq.eyebrow": "مركز المساعدة والاستفسارات",
    "faq.title": "الأسئلة الأكثر تداولاً",
    "faq.subtitle": "إجابات وافية وموثوقة حول خامات المايكروفايبر والقطن، مقاسات البرانص والفوط والبشاكير، تجهيزات العرايس، وطرق العناية والشحن.",
    "faq.searchPlaceholder": "ابحث في الأسئلة الشائعة (مثال: شحن، غسيل، مقاسات، عرايس)...",
    "faq.searchAria": "البحث في الأسئلة الشائعة",
    "faq.clearSearch": "مسح البحث",
    "faq.resultsCount": "تم العثور على {count} نتيجة مطابقة",
    "faq.noResultsTitle": "لم يتم العثور على نتائج مطابقة",
    "faq.noResultsDesc": "لم نتمكن من العثور على إجابة لكلمة البحث الحالية. يمكنك تجربة كلمات أخرى أو التواصل مع فريق الكونسيرج مباشرة.",
    "faq.resetSearch": "إعادة تعيين البحث",
    "faq.catAll": "الكل",
    "faq.catOrders": "الطلبات والتوصيل",
    "faq.catCotton": "الخامات والجودة",
    "faq.catSizing": "المقاسات والأبعاد",
    "faq.catCare": "العناية والغسيل",
    "faq.catReturns": "الاستبدال والضمان",
    "faq.conciergeTitle": "هل تحتاج لمساعدة فورية؟",
    "faq.conciergeSub": "فريق خدمة عملاء تيري لاند متاح لمساعدتك والإجابة عن أي استفسار خاص.",
    "faq.trackOrder": "متابعة طلباتي",
    "faq.trackOrderDesc": "معرفة حالة شحنتك الحالية وموعد التسليم",
    "faq.careGuide": "دليل العناية بالمنسوجات",
    "faq.careGuideDesc": "نصائح المحافظة على النعومة والامتصاص العالي",
    "faq.waConcierge": "محادثة واتساب مباشرة",
    "faq.waConciergeDesc": "تحدث فوراً مع أحد مسؤولي خدمة العملاء",
    "faq.stillHaveQuestions": "لم تجد الإجابة التي تبحث عنها؟",
    "faq.contactCta": "تواصل معنا الآن",

    // ── Blog / Journal Page ──
    "blog.metaTitle": "مجلة تيري لاند | نصائح جهاز العروسة واختيار البرانص والفوط والبشاكير",
    "blog.eyebrow": "مجلة تيري لاند",
    "blog.title": "مجلة تيري لاند | دليل العروسين والمفروشات الفاخرة",
    "blog.subtitle": "استكشف أسرار المنسوجات الراقية، دلائل جهاز العروسة ومفروشات بيت الزوجية، ومقارنات الخامات بين القطن، المايكروفايبر، وخامة الوجهين المبتكرة.",
    "blog.featuredBadge": "مقال الأسبوع المميز",
    "blog.readStory": "قراءة المقال بالكامل",
    "blog.readTime": "{minutes} دقائق قراءة",
    "blog.publishedOn": "نُشر في",
    "blog.author": "بقلم",
    "blog.atelierAuthor": "فريق تيري لاند",
    "blog.catAll": "جميع المقالات",
    "blog.catHeritage": "التراث والحرفة",
    "blog.catRituals": "طقوس الاسترخاء",
    "blog.catGuides": "أسرار الأقمشة",
    "blog.catCare": "دليل العناية",
    "blog.catInteriors": "ديكور وضيافة",
    "blog.shareStory": "مشاركة المقال",
    "blog.copiedToast": "تم نسخ رابط المقال بنجاح!",
    "blog.closeReader": "إغلاق نافذة القراءة",
    "blog.keyTakeaways": "خلاصة المقال وأبرز النقاط:",
    "blog.shopRecommended": "استكشف المنتجات ذات الصلة بالمقال:",
    "blog.exploreCollection": "تصفح المجموعة الآن",
    "blog.newsletterTitle": "انضم إلى دائرة تيري لاند الحصرية",
    "blog.newsletterSub": "احصل على مقالاتنا الموسمية الجديدة ودعوات لمعاينة المجموعات الفاخرة قبل طرحها.",
    "blog.newsletterPlaceholder": "أدخل بريدك الإلكتروني هنا...",
    "blog.newsletterSubscribe": "اشتراك",
    "blog.newsletterSuccess": "شكراً لانضمامك إلى مجلة تيري لاند!",

    // ── Thanks / Order Confirmation ──
    "thanks.title": "شكراً لطلبك!",
    "thanks.subtitle": "تم استلام وتأكيد طلبك بنجاح ونعمل الآن على تجهيزه بعناية فائقة.",
    "thanks.orderNumber": "رقم الطلب المرجعي:",
    "thanks.copy": "نسخ",
    "thanks.copied": "تم النسخ!",
    "thanks.deliveryEstimate": "المدة المتوقعة للتوصيل",
    "thanks.deliveryEstimateDays": "خلال 2 إلى 4 أيام عمل",
    "thanks.deliveryCourier": "يتم الشحن والتوصيل لباب منزلك عبر بوسطة",
    "thanks.timelineTitle": "مراحل تجهيز طلبك",
    "thanks.step1": "تم تأكيد الطلب",
    "thanks.step1Desc": "تم استلام الطلب وتأكيد البيانات",
    "thanks.step2": "قيد التجهيز والتغليف",
    "thanks.step2Desc": "فحص الجودة والتغليف الفاخر",
    "thanks.step3": "جاري الشحن مع المندوب",
    "thanks.step3Desc": "في الطريق إلى عنوانك المحدد",
    "thanks.step4": "تم التسليم",
    "thanks.step4Desc": "استلام مشترياتك والاستمتاع بها",
    "thanks.paymentMethod": "طريقة الدفع",
    "thanks.paymentCod": "الدفع نقداً عند الاستلام",
    "thanks.paymentCard": "تم الدفع إلكترونياً بنجاح",
    "thanks.orderSummary": "ملخص الطلب",
    "thanks.itemsCount": "{count} منتجات",
    "thanks.totalAmount": "إجمالي المبلغ المطلوب:",
    "thanks.shippingTo": "الشحن إلى:",
    "thanks.viewOrder": "عرض تفاصيل الطلب",
    "thanks.viewAllOrders": "طلباتي السابقة",
    "thanks.continueShopping": "متابعة التسوق",
    "thanks.needHelp": "هل لديك أي استفسار بخصوص طلبك؟",
    "thanks.contactSupport": "تواصل مع فريق الدعم",
    "thanks.metaTitle": "شكراً لطلبك | تيري لاند",

    // ── 404 Not Found Page ──
    "notFound.metaTitle": "404 - الصفحة غير موجودة | تيري لاند",
    "notFound.eyebrow": "خطأ 404 • الصفحة غير موجودة",
    "notFound.code": "404",
    "notFound.title": "عفواً، لم نتمكن من العثور على هذه الصفحة",
    "notFound.desc": "يبدو أن الصفحة التي تبحث عنها قد تم نقلها أو تعديل عنوانها، أو أنها لم تعد متوفرة. يمكنك العودة إلى المتجر أو استكشاف مجموعاتنا الفاخرة أدناه.",
    "notFound.backHome": "العودة إلى الصفحة الرئيسية",
    "notFound.exploreShop": "تصفح المتجر والمنتجات",
    "notFound.quickLinksTitle": "وجهات شائعة قد تبحث عنها:",
    "notFound.linkBathrobes": "أرواب وبرانس الحمام الفاخرة",
    "notFound.linkBathrobesDesc": "أرقى الخامات القطنية والمايكروفايبر والوجهين الفاخرة",
    "notFound.linkTowels": "المناشف والبشاكير الفندقية",
    "notFound.linkTowelsDesc": "نعومة فائقة وامتصاص استثنائي بمقاسات متعددة",
    "notFound.linkAbout": "قصة تيري لاند والحِرفة",
    "notFound.linkAboutDesc": "تراث فندقي عريق وأعلى معايير الجودة المصرية",
    "notFound.linkContact": "تواصل مع خدمة العملاء",
    "notFound.linkContactDesc": "فريقنا مستعد لمساعدتك في أي استفسار أو طلب خاص",
    "notFound.helpNote": "هل تحتاج مساعدة فورية أو تبحث عن قطعة مخصصة؟",
    "notFound.whatsappChat": "محادثة مباشرة عبر واتساب",

    // ── System & API Error Messages (Arabic) ──
    "errors.GENERIC_ERROR": "حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى لاحقاً.",
    "errors.INTERNAL_SERVER_ERROR": "حدث خطأ في الخادم. يرجى المحاولة مرة أخرى لاحقاً.",
    "errors.NETWORK_ERROR": "تعذر الاتصال بالخادم، يرجى التحقق من اتصالك بالإنترنت.",
    "errors.BAD_REQUEST": "طلب غير صالح، يرجى التحقق من البيانات المدخلة.",
    "errors.VALIDATION_FAILED": "يرجى التحقق من صحة البيانات المدخلة والمحاولة مجدداً.",
    "errors.RESOURCE_NOT_FOUND": "العنصر المطلوب غير موجود.",
    "errors.ALREADY_EXISTS": "هذا السجل موجود بالفعل مسبقاً.",
    "errors.DOMAIN_RULE_VIOLATION": "تعذر إتمام العملية وفقاً للشروط الحالية.",
    "errors.EXTERNAL_SERVICE_ERROR": "حدث خطأ أثناء الاتصال بالخدمة الخارجية، يرجى المحاولة لاحقاً.",

    // Auth & Identity
    "errors.AUTH_INVALID_CREDENTIALS": "اسم المستخدم أو كلمة المرور غير صحيحة.",
    "errors.AUTH_EMAIL_ALREADY_IN_USE": "هذا البريد الإلكتروني مسجل بالفعل لدينا.",
    "errors.AUTH_EMAIL_NOT_CONFIRMED": "يرجى تأكيد بريدك الإلكتروني قبل تسجيل الدخول.",
    "errors.AUTH_EMAIL_VERIFICATION_PENDING": "تم إرسال رابط التأكيد إلى بريدك الإلكتروني، يرجى مراجعة صندوق الوارد.",
    "errors.AUTH_EMAIL_VERIFICATION_THROTTLED": "تم إرسال بريد التأكيد مؤخراً، يرجى الانتظار دقيقة قبل طلب بريد جديد.",
    "errors.AUTH_INCOMPLETE_CREDENTIALS": "يرجى إدخال البريد الإلكتروني وكلمة المرور.",
    "errors.AUTH_INVALID_TOKEN": "رمز التحقق غير صالح أو انتهت صلاحيته.",
    "errors.USER_NOT_FOUND": "المستخدم غير موجود. يرجى تسجيل الدخول.",
    "errors.UNAUTHORIZED": "يرجى تسجيل الدخول للمتابعة.",
    "errors.FORBIDDEN": "ليس لديك الصلاحية لتنفيذ هذا الإجراء.",

    // Cart & Products
    "errors.CART_EMPTY": "سلة التسوق فارغة حالياً.",
    "errors.CART_MAX_QUANTITY_REACHED": "الحد الأقصى المسموح به هو 10 قطع من نفس المنتج.",
    "errors.CART_INVALID_QUANTITY": "لا يمكن تحديد الكمية بصفر.",
    "errors.CART_ITEM_NOT_FOUND": "العنصر غير موجود في سلة التسوق.",
    "errors.PRODUCT_UNAVAILABLE": "هذا المنتج غير متوفر حالياً.",
    "errors.PRODUCT_NOT_FOUND": "المنتج غير موجود.",
    "errors.INVALID_VARIANT": "التشكيلة المختارة (اللون والمقاس) غير متوفرة.",
    "errors.OUT_OF_STOCK": "نفدت الكمية المتاحة من هذا المنتج.",

    // Shipping & Addresses
    "errors.SHIPPING_ADDRESS_UNREACHABLE": "نعتذر، لا يمكننا التوصيل إلى هذا العنوان حالياً. يرجى اختيار عنوان آخر.",
    "errors.SHIPPING_INVALID_CITY_DISTRICT": "المحافظة والمنطقة المختارة غير متطابقتين.",
    "errors.SHIPPING_ADDRESS_INVALID": "بيانات عنوان الشحن غير صالحة.",
    "errors.ADDRESS_NOT_FOUND": "لم يتم العثور على العنوان المحدد.",

    // Orders & Checkout
    "errors.ORDER_PACKAGE_LIMIT_EXCEEDED": "يتجاوز حجم طلبك الحد الأقصى المسموح به للشحنة الواحدة، يرجى تقليل عدد المنتجات.",
    "errors.ORDER_NOT_FOUND": "لم يتم العثور على الطلب المحدد.",
    "errors.ORDER_CANNOT_CANCEL": "لا يمكن إلغاء هذا الطلب في وضعه الحالي.",
    "errors.ORDER_ALREADY_CANCELLED": "هذا الطلب ملغى بالفعل.",
    "errors.ORDER_CANNOT_REPAY": "لا يمكن إعادة الدفع لهذا الطلب.",
    "errors.ORDER_REFUND_LIMIT_EXCEEDED": "المبلغ المراد استرداده يتجاوز إجمالي الطلب.",
    "errors.ORDER_REFUND_PERIOD_EXPIRED": "لا يمكن استرداد المبلغ بعد مرور 10 أيام من تاريخ الشراء.",
    "errors.COUPON_INVALID": "كود الخصم غير صالح أو غير موجود.",
    "errors.COUPON_EXPIRED": "انتهت صلاحية كود الخصم.",
    "errors.COUPON_MIN_SPEND_NOT_MET": "قيمة الطلب لا تحقق الحد الأدنى لتفعيل هذا الكوبون.",
    "errors.COUPON_USAGE_LIMIT_EXCEEDED": "تم استنفاد الحد الأقصى لاستخدام هذا الكوبون.",

    // Direct English string fallback mapping for existing backend messages
    "errors.messages.Username or password is incorrect": "اسم المستخدم أو كلمة المرور غير صحيحة.",
    "errors.messages.Email is already in use": "هذا البريد الإلكتروني مسجل بالفعل لدينا.",
    "errors.messages.Use another email.": "هذا البريد الإلكتروني غير متاح، يرجى استخدام بريد آخر.",
    "errors.messages.Incomplete Credentials": "يرجى إدخال البريد الإلكتروني وكلمة المرور.",
    "errors.messages.Check your mailbox to confirm your email.": "تم إرسال رابط التحقق، يرجى مراجعة بريدك الإلكتروني.",
    "errors.messages.A verification email was recently sent. Please check your inbox or wait a minute before requesting another.": "تم إرسال بريد التأكيد مؤخراً، يرجى الانتظار دقيقة قبل المحاولة مرة أخرى.",
    "errors.messages.You have empty cart.": "سلة التسوق فارغة حالياً.",
    "errors.messages.Cart is empty": "سلة التسوق فارغة حالياً.",
    "errors.messages.Maximum 10 items of same product.": "الحد الأقصى المسموح به هو 10 قطع من نفس المنتج.",
    "errors.messages.Can't set quantity to zero": "لا يمكن تحديد الكمية بصفر.",
    "errors.messages.Your order exceeds the permitted package size. Please reduce the number of items.": "يتجاوز حجم طلبك الحد الأقصى المسموح به للشحنة، يرجى تقليل عدد المنتجات.",
    "errors.messages.Invalid combination of city and district.": "المحافظة والمنطقة المختارة غير متطابقتين.",
    "errors.messages.Please use different address. We can't reach to this location.": "نعتذر، لا يمكننا التوصيل إلى هذا العنوان. يرجى اختيار عنوان آخر.",
    "errors.messages.Please select another shipping address, We can't reach your current address.": "نعتذر، لا يمكننا التوصيل إلى هذا العنوان. يرجى اختيار عنوان آخر.",
    "errors.messages.This product is unavailable.": "هذا المنتج غير متوفر حالياً.",
    "errors.messages.Invalid variant combination.": "التشكيلة المختارة غير متوفرة.",
    "errors.messages.Login please.": "يرجى تسجيل الدخول أولاً.",
    "errors.messages.User not found": "المستخدم غير موجود.",
    "errors.messages.You are not authorized to cancel this order.": "ليس لديك الصلاحية لإلغاء هذا الطلب.",
    "errors.messages.This order is already cancelled.": "هذا الطلب ملغى بالفعل.",
    "errors.messages.Only pending or confirmed orders can be cancelled.": "يمكن إلغاء الطلبات قيد الانتظار أو المؤكدة فقط.",
    "errors.messages.You can't cancel this order currently.": "لا يمكن إلغاء هذا الطلب حالياً.",
    "errors.messages.You can't cancel this order currently. It's already in shipping or cancelled before.": "لا يمكن إلغاء هذا الطلب حالياً لأنه قيد الشحن بالفعل أو تم إلغاؤه.",
    "errors.messages.You can't cancel a completed order. If you want to return it, use the return function.": "لا يمكن إلغاء طلب مكتمل. يمكنك استخدام ميزة الإرجاع.",
    "errors.messages.Cannot ship a cancelled or returned order.": "لا يمكن شحن طلب ملغى أو مرتجع.",
    "errors.messages.Credit Card payment service is under construction.": "خدمة الدفع بالبطاقة الائتمانية قيد التحديث حالياً.",
    "errors.messages.Invalid coupon code.": "كود الخصم غير صالح.",
    "errors.messages.An unexpected error occurred. Please try again later.": "حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى لاحقاً.",
    "errors.messages.One or more validation failures have occurred.": "يرجى مراجعة البيانات المدخلة والتأكد من صحتها.",
  },

  en: {
    // ── Brand & Navigation ──
    "brand.name": "TERRY LAND",
    "brand.tagline": "Luxury textiles",
    "nav.home": "Home",
    "nav.about": "About Us",
    "nav.shop": "Shop",
    "nav.collections": "Collections",
    "nav.allCollections": "All Collections",
    "nav.blog": "Blog",
    "nav.contact": "Contact",
    "nav.account": "My Account",
    "nav.signIn": "Sign In",
    "nav.admin": "Admin",
    "nav.cart": "Cart",
    "nav.language": "العربية",
    "nav.languageAria": "Switch to Arabic language",
    "nav.theme": "Theme",
    "nav.themeAria": "Toggle dark and light theme",
    "nav.themeLight": "Light Mode",
    "nav.themeDark": "Dark Mode",
    "nav.themeSystem": "System Theme",

    // ── Common & Actions ──
    "action.addToCart": "Add to Cart",
    "action.adding": "Adding…",
    "action.added": "Added to Cart ✓",
    "action.viewProduct": "View Product",
    "action.viewCart": "View Cart",
    "action.shopNow": "Shop Now",
    "action.explore": "Explore Collection",
    "action.checkout": "Checkout",
    "action.continueShopping": "Continue Shopping",
    "action.save": "Save",
    "action.cancel": "Cancel",
    "action.delete": "Delete",
    "action.edit": "Edit",
    "action.filter": "Filter",
    "action.sortBy": "Sort by:",
    "action.subscribe": "Subscribe",
    "action.back": "Back",
    "action.backToShop": "Back to Shop",

    // ── Product Detail & Cards ──
    "product.color": "Color",
    "product.size": "Size",
    "product.quantity": "Quantity",
    "product.price": "Price",
    "product.selectColorAndSize": "Please choose a size and color.",
    "product.luxuryCollection": "Luxury Collection",
    "product.freeDeliveryNote": "Free shipping on orders over {amount}",
    "product.freeDelivery": "Free Delivery",
    "product.easyReturns": "Easy Returns",
    "product.securePayment": "Secure Payment",
    "product.guestNotice": "Guest checkout enabled ·",
    "product.signInLink": "Sign in",
    "product.saveBagNote": "to save your bag to an account.",
    "product.notFound": "This product could not be found.",
    "product.outOfStock": "Out of Stock",
    "product.inStock": "In Stock",
    "product.onlyLeft": "Only {count} left in stock!",
    "product.selectCombinationOutOfStock": "This size & color combination is out of stock. Please select another variant.",
    "product.zoomIn": "Zoom in",
    "product.zoomOut": "Zoom out",
    "product.resetZoom": "Reset zoom",
    "product.closeInspector": "Close inspector",
    "product.imageCount": "Image {current} of {total}",
    "product.recommendedEyebrow": "Curated Selection • Recommended",
    "product.recommendedTitle": "You May Also Like",
    "product.recommendedSubtitle": "Handcrafted luxury pieces to complement your Terry Land experience",
    "product.swipeHint": "Swipe horizontally to explore more",
    "product.sameCollectionBadge": "Same Collection",
    "product.fromCollectionBadge": "{name} Collection",

    // ── Features & USPs ──
    "feature.premium": "Premium Quality",
    "feature.premiumSub": "Finest materials",
    "feature.ultraSoft": "Ultra Soft",
    "feature.ultraSoftSub": "Gentle on your skin",
    "feature.timeless": "Timeless Design",
    "feature.timelessSub": "Elegant & sophisticated",
    "feature.sustainable": "Sustainable",
    "feature.sustainableSub": "Eco-friendly production",

    // ── Home Page ──
    "home.metaTitle": "Terry Land | Luxury Bathrobes, Towels & Bridal Linens — Cotton & Microfiber",
    "home.heroEyebrow": "Terry Land · Premium Luxury Textiles",
    "home.heroTitleLine1": "Wrap Yourself",
    "home.heroTitleLine2": "in Luxury",
    "home.heroSub": "Luxury bathrobes, hotel-grade towels, and bridal linen collections crafted from ultra-soft cotton & microfiber blends.",
    "home.scroll": "Scroll",
    "home.curatedLabel": "Curated for you",
    "home.curatedTitle": "Our Curated Collections",
    "home.curatedDesc": "Discover our carefully curated collections designed to bring comfort, elegance, and style to your everyday life.",
    "home.bestsellingLabel": "Handpicked",
    "home.bestsellingTitle": "Bestselling Bathrobes, Towels & Linens",
    "home.viewAllProducts": "View All Products",
    "home.craftedLabel": "Our Commitment",
    "home.craftedTitle": "Crafted with Care & Sustainability",
    "home.craftedText1": "Every Terry Land piece is woven with precision. We combine ultra-soft microfiber with natural cotton fibers to ensure effortless absorbency, lightweight comfort, and enduring softness without pilling.",
    "home.craftedText2": "Our artisans bring decades of experience, combining traditional weaving techniques with modern innovation to create textiles that transform your daily rituals into moments of pure luxury.",
    "home.ourStory": "Our Story",
    "home.statYears": "Years of Excellence",
    "home.statCustomers": "Happy Customers",
    "home.statCotton": "Quality Assurance",
    "home.statRating": "Average Rating",
    "home.collBaby": "Baby Collection",
    "home.collBabySub": "Soft. Safe. Gentle.",
    "home.collTowels": "Towel Collection",
    "home.collTowelsSub": "Absorbent. Plush. Luxurious.",
    "home.collRobes": "Bathrobe Collection",
    "home.collRobesSub": "Relax in Style.",

    // ── Shop Page ──
    "shop.metaTitle": "The Shop | Bathrobes, Towels & Bridal Collections — Terry Land",
    "shop.title": "The Shop",
      "shop.subtitle": "Premium textiles, crafted with exceptional care to bring you everyday comfort.",
    "shop.all": "All Collections",
    "shop.results": "Showing {count} results",
    "shop.showing": "Showing {count} of {total} products",
    "shop.noProducts": "No products found in this category.",
    "shop.sort.collection": "Category / Collection",
    "shop.sort.bestselling": "Best Sellers",
    "shop.sort.newest": "Newest",
    "shop.sort.priceAsc": "Price: Low to High",
    "shop.sort.priceDesc": "Price: High to Low",
    "product.bestSeller": "Best Seller",
    "shop.luxuryBannerEyebrow": "Since 1956 • The Atelier Story",
    "shop.luxuryBannerTitle": "Behind Every Thread, Decades of Passion & Textile Mastery",
      "shop.luxuryBannerSub": "Decades of experience, weaving luxury and comfort into every detail.",
    "shop.luxuryBannerCta": "Discover the Terry Land Story",
    "shop.luxuryBannerTag1": "Premium Cotton & Ultra-Soft Microfiber",
    "shop.luxuryBannerTag2": "Master Loom Weaving Craft",
    "shop.luxuryBannerTag3": "Over 65 Years of Textile Excellence",
    "shop.searchPlaceholder": "Search products by name, fabric, style…",
    "shop.filterDrawerTitle": "Filter Products",
    "shop.categories": "Collections & Categories",
    "shop.priceRange": "Price Range",
    "shop.minPrice": "Min Price",
    "shop.maxPrice": "Max Price",
    "shop.resetFilters": "Reset Filters",
    "shop.applyFilters": "Apply Filters",
    "shop.activeFilters": "Active Filters:",
    "shop.clearAll": "Clear All",
    "shop.noProductsTitle": "No products match your criteria",
    "shop.noProductsHint": "Try adjusting your search query or removing selected filters to see more pieces.",
    "shop.egp": "EGP",
    "shop.priceUnder500": "Under 500 EGP",
    "shop.price500to1500": "500 - 1,500 EGP",
    "shop.priceOver1500": "Over 1,500 EGP",
    "shop.collectionTag": "Curated Collection",

    // ── Cart & Checkout ──
    "cart.title": "Shopping Bag",
    "cart.empty": "Your shopping bag is currently empty.",
    "cart.emptyDesc": "Explore our luxury collections and add everyday elegance to your life.",
    "cart.product": "Product",
    "cart.unitPrice": "Price",
    "cart.total": "Total",
    "cart.subtotal": "Subtotal",
    "cart.shipping": "Estimated Shipping",
    "cart.shippingCalc": "Calculated at checkout",
    "cart.orderSummary": "Order Summary",
    "cart.proceedCheckout": "Proceed to Checkout",
    "cart.remove": "Remove",
    "cart.stepBag": "Shopping Bag",
    "cart.stepCheckout": "Checkout",
    "cart.stepDone": "Confirmation",
    "cart.freeShippingUnlocked": "🎉 Congratulations! You qualify for Free Delivery",
    "cart.freeShippingRemaining": "Add {amount} more to unlock Free Delivery!",
    "cart.continueShopping": "Continue Shopping",
    "cart.secureCheckout": "100% Secure & Encrypted Checkout",
    "cart.fastDelivery": "Fast Delivery to Your Doorstep",
    "cart.easyReturns": "Hassle-Free Easy Returns & Exchanges",
    "cart.explorePrompt": "Explore popular collections:",
    "cart.packageLimitExceeded": "Your cart exceeds the maximum permitted shipping package size. Please reduce the number of items.",
    "cart.packageLimitExceededBannerTitle": "Shipping Package Limit Exceeded",
    "cart.packageLimitExceededBannerDesc": "Your order exceeds the maximum package shipping volume allowed by courier (maximum {maxVolume} cm³). Please reduce item quantities or remove some items before proceeding to checkout.",
    "cart.packageLimitItemCannotAdd": "Cannot add this item: Your cart would exceed the maximum permitted shipping package size. Please reduce other items first.",
    "cart.packageLimitItemCannotIncrease": "Cannot increase quantity: This would exceed the maximum permitted shipping package size.",
    "cart.mustReduceItemsToCheckout": "Please reduce the quantity of items in your cart to proceed with checkout as it exceeds shipping package capacity.",
    "cart.packageCapacity": "Shipping Package Capacity",
    "cart.packageLimitReached": "Maximum shipping package limit reached",

    // ── Coupon / Promo ──
    "coupon.havePromo": "Have a promo code?",
    "coupon.placeholder": "Enter promo code (e.g. SUMMER20)",
    "coupon.apply": "Apply",
    "coupon.applying": "Applying…",
    "coupon.remove": "Remove code",
    "coupon.discount": "Discount",
    "coupon.saved": "Saved {amount}",
    "coupon.applied": "Promo code ({code}) applied successfully!",
    "coupon.enterCode": "Please enter a promo code.",

    // ── Checkout ──
    "checkout.title": "Checkout",
    "checkout.subtitle": "Provide your delivery and payment details to complete your order",
    "checkout.shippingAddress": "Shipping & Delivery Address",
    "checkout.billingAddress": "Billing Address",
    "checkout.billingSameAsShipping": "Billing address same as shipping address",
    "checkout.paymentMethod": "Payment Method",
    "checkout.cod": "Cash on Delivery (COD)",
    "checkout.codSub": "Pay in cash upon doorstep delivery via courier",
    "checkout.card": "Credit / Debit Card (Paymob)",
    "checkout.cardSub": "Instant, encrypted card payment via Paymob",
    "checkout.wallet": "Mobile Wallet",
    "checkout.walletSub": "Vodafone Cash, Orange, smart mobile wallets",
    "checkout.placeOrder": "Place Order Now",
    "checkout.differentAddress": "Choose different address",
    "checkout.addNewAddress": "Add new address",
    "checkout.noAddressPrompt": "You haven't added any addresses yet.",
    "checkout.addShippingAddress": "Add shipping address",
    "checkout.addBillingAddress": "Add billing address",
    "checkout.selectedBadge": "Selected Delivery Address",
    "checkout.defaultBadge": "Default",
    "checkout.modalSelectTitle": "Select Delivery Address",
    "checkout.modalAddTitle": "Add New Address",
    "checkout.country": "Country",
    "checkout.city": "City",
    "checkout.selectCity": "Select a city",
    "checkout.district": "District",
    "checkout.selectDistrict": "Select or search district",
    "checkout.streetDesc": "Street / building details",
    "checkout.streetPlaceholder": "e.g. 14 El Nasr St., Apt 5",
    "checkout.phone": "Contact phone number",
    "checkout.phonePlaceholder": "Mobile number",
    "checkout.setDefault": "Set as primary default address",
    "checkout.saveAddress": "Save Address",
    "checkout.savingAddress": "Saving…",
    "checkout.orderSummary": "Order Summary",
    "checkout.trustSecure": "100% Secure & Encrypted",
    "checkout.trustDelivery": "Fast doorstep delivery via Bosta",
    "checkout.trustReturns": "14-Day Easy Returns Guarantee",
    "checkout.missingShipping": "Please select a shipping address.",
    "checkout.missingBilling": "Please select a billing address.",
    "checkout.emptyCart": "Your shopping bag is currently empty.",
    "checkout.continueShopping": "Continue shopping",
    "checkout.backToCart": "Back to shopping bag",
    "checkout.processing": "Processing order…",
    "checkout.itemsInOrder": "Items in Order",

    // ── Guest Checkout ──
    "guestCheckout.title": "Guest Checkout",
    "guestCheckout.subtitle": "Fast & secure checkout without creating an account",
    "guestCheckout.haveAccount": "Already have an account?",
    "guestCheckout.signIn": "Sign in here",
    "guestCheckout.contactInfo": "Contact Information",
    "guestCheckout.contactSub": "We will send order verification and shipment tracking details to this email.",
    "guestCheckout.email": "Email Address",
    "guestCheckout.emailPlaceholder": "name@example.com",
    "guestCheckout.firstName": "First Name",
    "guestCheckout.firstNamePlaceholder": "First name",
    "guestCheckout.lastName": "Last Name",
    "guestCheckout.lastNamePlaceholder": "Last name",
    "guestCheckout.deliveryAddress": "Delivery Address",
    "guestCheckout.country": "Country",
    "guestCheckout.egypt": "Egypt",
    "guestCheckout.city": "City",
    "guestCheckout.selectCity": "Select a city",
    "guestCheckout.loadingCities": "Loading cities…",
    "guestCheckout.district": "District",
    "guestCheckout.selectDistrict": "Select or search district",
    "guestCheckout.selectCityFirst": "Select a city first",
    "guestCheckout.loadingDistricts": "Loading districts…",
    "guestCheckout.streetDetails": "Street, Building & Floor Details",
    "guestCheckout.streetPlaceholder": "e.g. 14 El-Gomhoureya St, Building 4B, 3rd Floor, Apt 12",
    "guestCheckout.minCharsNotice": "{count}/25 min chars",
    "guestCheckout.streetHint": "Please provide full details so the Bosta courier can locate you easily.",
    "guestCheckout.phone": "Mobile Phone Number",
    "guestCheckout.phonePlaceholder": "Mobile number",
    "guestCheckout.phoneHint": "You can enter the number as 01022334455 or 1022334455 for delivery coordination.",
    "guestCheckout.paymentMethod": "Payment Method",
    "guestCheckout.cod": "Cash on Delivery (COD)",
    "guestCheckout.codSub": "Pay in cash upon doorstep delivery via Bosta courier",
    "guestCheckout.orderSummary": "Order Summary",
    "guestCheckout.subtotal": "Subtotal",
    "guestCheckout.shipping": "Shipping (Bosta)",
    "guestCheckout.calculating": "Calculating...",
    "guestCheckout.freeShipping": "Free",
    "guestCheckout.shippingUnavailable": "Unavailable",
    "guestCheckout.selectDistrictHint": "Select district",
    "guestCheckout.calcPrompt": "Choose your city and district above to calculate delivery fees.",
    "guestCheckout.totalDue": "Total Due",
    "guestCheckout.placeOrder": "Place Guest Order",
    "guestCheckout.placingOrder": "Placing Order…",
    "guestCheckout.backToCart": "Back to shopping bag",
    "guestCheckout.trustShipping": "Fast shipping across Egypt via Bosta",
    "guestCheckout.trustCod": "Pay with Cash on Delivery at your door",
    "guestCheckout.trustReturns": "14-Day Easy Returns Guarantee",
    "guestCheckout.errVariants": "Your cart items are missing variant information.",
    "guestCheckout.errDescMin": "Please provide at least 25 characters of address details for delivery.",
    "guestCheckout.errPhone": "Please enter a valid Egyptian mobile number (e.g., 010xxxxxxxx or 10xxxxxxxx).",
    "guestCheckout.errCity": "Please select a city and district.",
    "guestCheckout.errFailed": "Guest checkout failed. Please try again.",
    "guestCheckout.successToast": "Your order has been placed successfully!",
    "guestCheckout.successTitle": "Order Placed Successfully!",
    "guestCheckout.orderConfirmedBadge": "Order Placed Successfully",
    "guestCheckout.orderReference": "Order Reference:",
    "guestCheckout.copy": "Copy",
    "guestCheckout.copied": "Copied!",
    "guestCheckout.createPasswordSub": "Your order is confirmed for {email}. Create a password now to join us and save your order history, or continue shopping as a guest.",
    "guestCheckout.createPasswordLabel": "Create Password",
    "guestCheckout.createPasswordPlaceholder": "Enter your password",
    "guestCheckout.confirmPasswordLabel": "Confirm Password",
    "guestCheckout.confirmPasswordPlaceholder": "Confirm your password",
    "guestCheckout.passwordRequirements": "Password Requirements",
    "guestCheckout.reqLength": "At least 8 characters",
    "guestCheckout.setPasswordAndJoin": "Set Password & Join",
    "guestCheckout.activatingAccount": "Activating Account...",
    "guestCheckout.or": "Or",
    "guestCheckout.continueAsGuest": "Continue Shopping as Guest",
    "guestCheckout.accountCreatedTitle": "Account Activated Successfully!",
    "guestCheckout.accountCreatedDesc": "Welcome aboard! Your guest order is now permanently linked to your account and you are logged in. You can track your shipment and view your orders at any time.",
    "guestCheckout.accountCreatedToast": "Your account has been successfully created & activated!",
    "guestCheckout.viewMyOrders": "View & Track My Orders",
    "guestCheckout.errPasswordLength": "Password must be between 8 and 30 characters.",
    "guestCheckout.errPasswordMatch": "Passwords do not match.",
    "guestCheckout.continueShopping": "Continue Shopping",
    "guestCheckout.backHome": "Back to Home",
    "guestCheckout.emptyTitle": "Your bag is empty",
    "guestCheckout.emptyDesc": "You don't have any items in your bag to checkout.",
    "guestCheckout.exploreCollections": "Explore Collections",
    "guestCheckout.successHeroSub": "Thank you, {name}! Your order has been placed and confirmed. A confirmation receipt and shipment details have been dispatched to {email}.",
    "guestCheckout.deliveryEstimate": "Estimated Delivery",
    "guestCheckout.deliveryEstimateVal": "2 to 4 Business Days",
    "guestCheckout.courierName": "Express Courier via Bosta",
    "guestCheckout.courierLabel": "Courier Partner",
    "guestCheckout.recipientLabel": "Recipient",
    "guestCheckout.phoneLabel": "Contact Number",
    "guestCheckout.paymentLabel": "Payment Method",
    "guestCheckout.paymentCodVal": "Cash on Delivery (COD)",
    "guestCheckout.paymentCardVal": "Online Card Payment",
    "guestCheckout.timelineTitle": "Order & Delivery Progress",
    "guestCheckout.step1Title": "Order Confirmed",
    "guestCheckout.step1Desc": "Receipt dispatched to your email",
    "guestCheckout.step2Title": "Processing & Packing",
    "guestCheckout.step2Desc": "Carefully preparing your package",
    "guestCheckout.step3Title": "Out for Delivery",
    "guestCheckout.step3Desc": "Handed to Bosta courier",
    "guestCheckout.step4Title": "Delivered",
    "guestCheckout.step4Desc": "Safe doorstep delivery",
    "guestCheckout.trackAccountSectionBadge": "Official Account & Order Tracking",
    "guestCheckout.trackAccountTitle": "Create an Official Account & Track Your Orders",
    "guestCheckout.trackAccountSub": "To protect your security and privacy, we will send a secure password creation link to your email ({email}). Open the link in your email to set your password and activate your account.",
    "guestCheckout.featureLiveTrack": "Real-time Bosta shipment tracking",
    "guestCheckout.featureInvoices": "View digital receipts & order history",
    "guestCheckout.featureQuickCheckout": "1-click faster checkout for next time",
    "guestCheckout.sendSetupLinkBtn": "Send Password Setup Link to My Email",
    "guestCheckout.sendingLink": "Sending link...",
    "guestCheckout.linkSentBadge": "Link Sent Successfully",
    "guestCheckout.linkSentTitle": "Check Your Email Inbox",
    "guestCheckout.linkSentDesc": "We sent a secure password setup link to {email}. Open the email and click the link to set your password and join us.",
    "guestCheckout.linkSentSpamNotice": "Note: If you don't see the email in your inbox, please check your Spam or Junk folder.",
    "guestCheckout.resendPrompt": "Didn't receive the email yet?",
    "guestCheckout.resendBtn": "Resend Link",
    "guestCheckout.resendCooldown": "Resend in ({seconds}s)",
    "guestCheckout.fastSetupBadge": "100% Secure • Link valid for 24 hours",
    "guestCheckout.cancelBtn": "Close Form",
    "guestCheckout.resetFeatureTabTitle": "How to access your account & track orders later?",
    "guestCheckout.resetFeatureTip1": "If you don't wish to set a password now, you can always use our",
    "guestCheckout.resetFeatureTipHighlight": "'Forgot Password / Reset Password' feature",
    "guestCheckout.resetFeatureTip2": "on the Sign In page using your checkout email ({email}) to access your account and track this order (#{orderId}) anytime.",
    "guestCheckout.goToLogin": "Go to Sign In Page",
    "guestCheckout.trackMyOrderBtn": "Track My Order",
    "guestCheckout.accountCreatedSuccessBadge": "Account Activated & Logged In",
    "guestCheckout.accountActiveNotice": "Welcome aboard! Your account has been activated and you are now signed in. You can now monitor this order directly from your personal orders dashboard.",
    "guestCheckout.needHelp": "Need help or have questions regarding your order?",
    "guestCheckout.contactSupport": "Contact Customer Support",

    // ── Verify Email & Order Confirmation ──
    "verifyEmail.verifyingTitle": "Verifying",
    "verifyEmail.verifyingMessage": "Verifying your email and order...",
    "verifyEmail.failedTitle": "Verification Failed",
    "verifyEmail.errMissingParams": "Invalid verification link. Missing email or token.",
    "verifyEmail.errFailedDefault": "Failed to verify email. The link may have expired or is invalid.",
    "verifyEmail.returnHome": "Return to Home",
    "verifyEmail.orderConfirmedTitle": "Order & Email Confirmed",
    "verifyEmail.emailVerifiedTitle": "Email Verified",
    "verifyEmail.guestConfirmedMessage": "Your order and email have been successfully confirmed!",
    "verifyEmail.guestPreparingMessage": "Your email and order have been successfully confirmed! Our team is preparing your package for delivery.",
    "verifyEmail.standardSuccessMessage": "Your email has been successfully verified! You can now sign in to your account.",
    "verifyEmail.goToSignIn": "Go to Sign In",
    "verifyEmail.continueShopping": "Continue Shopping",
    "verifyEmail.orderBadgeConfirmed": "Order & Email Confirmed",
    "verifyEmail.orderPlacedTitle": "Order Placed Successfully!",
    "verifyEmail.guestOrderIntro": "Your order is confirmed for {email}. Create a password now to join us and save your order history, or continue shopping as a guest.",
    "verifyEmail.createPasswordLabel": "Create Password",
    "verifyEmail.passwordPlaceholder": "Enter your password",
    "verifyEmail.confirmPasswordLabel": "Confirm Password",
    "verifyEmail.confirmPasswordPlaceholder": "Confirm your password",
    "verifyEmail.showPassword": "Show password",
    "verifyEmail.hidePassword": "Hide password",
    "verifyEmail.requirementsTitle": "Password Requirements",
    "verifyEmail.reqLength": "At least 8 characters (up to 30)",
    "verifyEmail.errPasswordLength": "Password must be between 8 and 30 characters.",
    "verifyEmail.errPasswordMatch": "Passwords do not match.",
    "verifyEmail.errSetPasswordFailed": "Failed to set password. The link may have expired.",
    "verifyEmail.activatingAccount": "Activating Account...",
    "verifyEmail.setPasswordAndJoin": "Set Password & Join",
    "verifyEmail.or": "Or",
    "verifyEmail.continueAsGuest": "Continue Shopping as Guest",
    "verifyEmail.accountCreatedTitle": "Account Created!",
    "verifyEmail.accountCreatedIntro": "Welcome aboard! Your guest order is now permanently linked to your account. You can track your shipment and view past orders at any time.",
    "verifyEmail.viewMyOrders": "View My Orders",
    "verifyEmail.toastAccountCreated": "Your account has been successfully created!",
    "verifyEmail.themeMode": "Theme",
    "verifyEmail.themeLight": "Light",
    "verifyEmail.themeDark": "Dark",
    "verifyEmail.themeSystem": "System",
    "verifyEmail.language": "Language",

    // ── Reset Password ──
    "resetPassword.title": "Create New Password",
    "resetPassword.subtitle": "Please enter your new password below to continue.",
    "resetPassword.passwordLabel": "New Password",
    "resetPassword.passwordPlaceholder": "Enter new password",
    "resetPassword.confirmPasswordLabel": "Confirm New Password",
    "resetPassword.confirmPasswordPlaceholder": "Re-enter new password",
    "resetPassword.requirementsTitle": "Password Requirements",
    "resetPassword.reqLength": "At least 8 characters (up to 30)",
    "resetPassword.showPassword": "Show password",
    "resetPassword.hidePassword": "Hide password",
    "resetPassword.submitBtn": "Update Password",
    "resetPassword.submitting": "Updating Password...",
    "resetPassword.successTitle": "Password Reset Successfully!",
    "resetPassword.successSubtitle": "Your password has been successfully updated. You can now sign in and access your account.",
    "resetPassword.proceedToSignIn": "Proceed to Sign In",
    "resetPassword.invalidTitle": "Invalid or Expired Link",
    "resetPassword.invalidSubtitle": "This password reset link is invalid, missing required parameters, or has expired.",
    "resetPassword.requestNewLink": "Request New Link",
    "resetPassword.errPasswordMatch": "Passwords do not match.",
    "resetPassword.errPasswordLength": "Password must be between 8 and 30 characters.",
    "resetPassword.errFailedDefault": "Failed to reset password. The link may have expired.",
    "resetPassword.toastSuccess": "Password updated successfully!",

    // ── Forgot Password ──
    "forgotPassword.title": "Reset Password",
    "forgotPassword.subtitle": "Enter your email address and we'll send you a link to reset your password.",
    "forgotPassword.emailLabel": "Email Address",
    "forgotPassword.emailPlaceholder": "name@example.com",
    "forgotPassword.submitBtn": "Send Reset Link",
    "forgotPassword.submitting": "Sending...",
    "forgotPassword.backToSignIn": "Back to Sign In",
    "forgotPassword.checkEmailTitle": "Check Your Email",
    "forgotPassword.checkEmailSubtitle": "We have sent a password reset link to",
    "forgotPassword.returnToSignIn": "Return to Sign In",
    "forgotPassword.errFailedDefault": "Failed to send reset link. Please try again.",
    "forgotPassword.toastSent": "Password reset link sent successfully!",

    // ── Authentication (Login) ──
    "auth.welcomeBack": "Welcome Back",
    "auth.signIn": "Sign In",
    "auth.signInSub": "Access your orders, saved addresses, and persistent shopping bag.",
    "auth.email": "Email Address",
    "auth.emailPlaceholder": "name@example.com",
    "auth.password": "Password",
    "auth.passwordPlaceholder": "••••••••",
    "auth.forgotPassword": "Forgot Password?",
    "auth.showPassword": "Show password",
    "auth.hidePassword": "Hide password",
    "auth.rememberMe": "Remember me on this device",
    "auth.signingIn": "Signing in…",
    "auth.loginSuccess": "Successfully signed in. Welcome back!",
    "auth.loginError": "Unable to sign in. Please verify your email and password.",
    "auth.noAccount": "New to Terry Land?",
    "auth.createAccount": "Create an account",
    "auth.checkoutNotice": "Sign in to proceed with your account, or checkout as a guest:",
    "auth.continueAsGuest": "Fast Guest Checkout",
    "auth.trustSecurity": "100% Secure & Encrypted Authentication",

    // ── Account & Subpages ──
    "account.sectionLabel": "Your Account",
    "account.title": "Manage your Terry Land experience",
    "account.welcome": "Welcome back",
    "account.memberBadge": "Privileged Member",
    "account.profileTitle": "Personal Profile",
    "account.profileDesc": "Update your name, contact information, and preferences.",
    "account.profileAction": "Edit profile",
    "account.addressesTitle": "Address Book",
    "account.addressesDesc": "Manage shipping and billing locations for effortless checkout.",
    "account.addressesAction": "Manage addresses",
    "account.ordersTitle": "Orders & Purchases",
    "account.ordersDesc": "Track fulfillment, delivery progress, and past purchase history.",
    "account.ordersAction": "View orders",
    "account.supportTitle": "Customer Concierge",
    "account.supportDesc": "Direct WhatsApp assistance, styling advice, and textile care support.",
    "account.supportAction": "Contact Concierge",
    "account.signOutTitle": "Sign Out",
    "account.signOutDesc": "Sign out of your account securely on this device.",
    "account.signOutAction": "Sign out",

    // ── Profile Subpage ──
    "profile.back": "Back to Account",
    "profile.sectionLabel": "Account Details",
    "profile.title": "Personal Profile",
    "profile.verified": "Active Verified Account",
    "profile.firstName": "First Name",
    "profile.firstNamePlaceholder": "Enter your first name",
    "profile.lastName": "Last Name",
    "profile.lastNamePlaceholder": "Enter your last name",
    "profile.save": "Save Changes",
    "profile.saving": "Saving…",
    "profile.success": "Profile details updated successfully.",
    "profile.error": "Failed to update profile. Please try again.",
    "profile.loadError": "Could not load profile details.",

    // ── Addresses Subpage ──
    "addresses.back": "Back to Account",
    "addresses.sectionLabel": "Shipping & Delivery",
    "addresses.title": "Address Book",
    "addresses.empty": "No saved addresses found. Add your first address to accelerate checkout.",
    "addresses.defaultBadge": "Default Address",
    "addresses.edit": "Edit",
    "addresses.remove": "Remove",
    "addresses.add": "Add New Address",
    "addresses.newTitle": "New Address",
    "addresses.editTitle": "Edit Address",
    "addresses.country": "Country",
    "addresses.egypt": "Egypt",
    "addresses.city": "City / Governorate",
    "addresses.selectCity": "Select city or governorate",
    "addresses.district": "District / Neighborhood",
    "addresses.selectDistrict": "Select district",
    "addresses.description": "Street & Building Details",
    "addresses.descriptionPlaceholder": "Building name, street, apartment or suite number",
    "addresses.phone": "Contact Phone Number",
    "addresses.phonePlaceholder": "Mobile number",
    "addresses.setDefault": "Set as default shipping address",
    "addresses.cancel": "Cancel",
    "addresses.save": "Save Address",
    "addresses.saving": "Saving…",
    "addresses.confirmDelete": "Are you sure you want to remove this address?",
    "addresses.saveSuccess": "Address saved successfully.",
    "addresses.deleteSuccess": "Address removed successfully.",
    "addresses.loadError": "Could not load addresses.",

    // ── Orders Subpage ──
    "orders.back": "Back to Account",
    "orders.sectionLabel": "Purchases",
    "orders.title": "Your Orders",
    "orders.empty": "You have not placed any orders yet.",
    "orders.emptySub": "Explore our curated bathrobes, towels, and bridal collections.",
    "orders.startShopping": "Explore Collection",
    "orders.orderNum": "Order",
    "orders.previous": "Previous",
    "orders.next": "Next",
    "orders.page": "Page {page}",
    "orders.loadError": "Could not load orders.",

    // ── Order Detail Subpage ──
    "orderDetail.back": "All Orders",
    "orderDetail.sectionLabel": "Order Details",
    "orderDetail.orderNumber": "Order",
    "orderDetail.total": "Total Amount",
    "orderDetail.shippingTitle": "Delivery Destination",
    "orderDetail.billingTitle": "Billing Information",
    "orderDetail.itemsTitle": "Purchased Items",
    "orderDetail.buyAgain": "Buy Again",
    "orderDetail.notFound": "The requested order could not be found.",
    "orderDetail.backToOrders": "Return to Orders List",
    "orderDetail.cancelOrder": "Cancel Order",
    "orderDetail.cancelling": "Cancelling...",
    "orderDetail.cancelConfirmTitle": "Confirm Order Cancellation",
    "orderDetail.cancelConfirmMsg": "Are you sure you want to cancel this order? Any payment will be refunded and shipment cancelled.",
    "orderDetail.cancelConfirmBtn": "Yes, Cancel Order",
    "orderDetail.cancelKeepBtn": "Keep Order",
    "orderDetail.cancelSuccess": "Order cancelled successfully.",
    "orderDetail.cancelError": "Failed to cancel order, please try again later.",
    "orderDetail.copyOrderNumber": "Copy Order ID",
    "orderDetail.copied": "Copied!",
    "orderDetail.copiedToast": "Order ID copied to clipboard!",
    "orderDetail.copyHint": "Copy",
    "orderDetail.supportBtn": "Problem or Return?",
    "orderDetail.supportBtnTooltip": "Contact customer support or request a return",
    "orderDetail.supportModalTitle": "Need Help or Wish to Make a Return?",
    "orderDetail.supportModalSubtitle": "We're here to assist you! Under Terry Land's 14-day policy, if there is any issue with your order or you wish to request an exchange or return, connect directly with our concierge team:",
    "orderDetail.supportWhatsappTitle": "Direct WhatsApp Concierge",
    "orderDetail.supportWhatsappDesc": "Instant support and fastest response time",
    "orderDetail.supportContactTitle": "Contact Concierge Form",
    "orderDetail.supportContactDesc": "Submit an inquiry to customer care",
    "orderDetail.supportCallTitle": "Direct Phone Call",
    "orderDetail.supportCallDesc": "Available daily from 10 AM to 10 PM",
    "orderDetail.supportBannerTitle": "Have an issue or want to return items from this order?",
    "orderDetail.supportBannerDesc": "Under our 14-day return & exchange policy, if there's any defect or sizing issue, speak directly with our team via WhatsApp or our Contact Us page.",
    "orderDetail.whatsappAction": "Chat on WhatsApp",
    "orderDetail.contactAction": "Contact Us",
    "orderDetail.closeModal": "Close",
    "orderDetail.bostaTrackingTitle": "Bosta Shipment Tracking",
    "orderDetail.bostaTrackingSubtitle": "Track your package in real-time with Bosta using your courier tracking number below:",
    "orderDetail.bostaTrackingNumber": "Bosta Tracking Number",
    "orderDetail.bostaCopyTracking": "Copy Tracking Number",
    "orderDetail.bostaCopiedTracking": "Tracking Number Copied!",
    "orderDetail.bostaTrackBtn": "Track on Bosta",
    "orderDetail.bostaAirwayBill": "View Airway Bill",
    "orderDetail.bostaDispatched": "Created Date",
    "orderDetail.bostaPreparing": "Your order is in the shipping stage. It is being prepared for pickup by Bosta courier. Your tracking number will appear once scanned.",
    "orderDetail.bostaMultipleNotice": "This order contains multiple shipments (e.g. initial delivery and return/exchange pickups). You can track each shipment individually.",

    // ── Footer ──
    "footer.tagline": "Premium bathrobes and towels, crafted for comfort and elegance.",
    "footer.colShop": "Shop",
    "footer.colCompany": "Company",
    "footer.colSupport": "Support",
    "footer.colContact": "Contact",
    "footer.newsletterTitle": "Indulge in Everyday Luxury",
    "footer.newsletterSub": "Subscribe to receive special offers, new collections, and exclusive updates.",
    "footer.newsletterPlaceholder": "Your email address",
    "footer.privacy": "Privacy Policy",
    "footer.terms": "Terms of Service",
    "footer.cookies": "Cookie Policy",
    "footer.rights": "© 2026 Terry Land. All rights reserved.",

    // ── About Page ──
    "about.metaTitle": "About Us | Terry Land - Bathrobes, Towels & Fine Linens Since 1956",
    "about.breadcrumbHome": "Home",
    "about.breadcrumbCurrent": "About Us",
    "about.heroEyebrow": "Our Heritage",
    "about.heroTitle": "A Leading Company in the Terry Textile Industry",
    "about.heroSubtitle": "At Terry Land, we believe everyday textiles should feel extraordinary. Our bathrobes and towels are designed for those who appreciate quiet luxury, exceptional softness, and lasting quality.",
    "about.storyBadge": "Since 1956 • Storied Heritage",
    "about.storyTitle": "A Heritage of Expertise. A Vision for the Future.",
    "about.storyP1": "Since 1956, we have cultivated decades of expertise in the terry textile industry—from understanding and refining raw materials to mastering the finest details of craftsmanship.",
    "about.storyP2": "Today, we carry this expertise forward through Terry Land: a new brand carrying a storied heritage, reimagined with a contemporary spirit that places innovation, quality, and comfort at the heart of every product.",
    "about.storyValue1": "Innovation",
    "about.storyValue1Desc": "A modern vision reimagining terry textiles with contemporary, forward-thinking designs.",
    "about.storyValue2": "Uncompromising Quality",
    "about.storyValue2Desc": "Meticulous fiber selection and strict tailoring controls built to endure for years.",
    "about.storyValue3": "Supreme Comfort",
    "about.storyValue3Desc": "Silky-smooth softness and a gentle touch that turns daily routines into a serene sanctuary.",
    "about.storyCardTag": "Heritage & Evolution",
    "about.storyCardYear": "1956",
    "about.storyCardSubtitle": "Over Half a Century of Textile Excellence",
    "about.storyCardQuote": "Decades of terry mastery, carried forward today to redefine everyday luxury and comfort with a contemporary spirit.",
    "about.storyCardAuthor": "Terry Land team",
    "about.visionEyebrow": "Our Aspiration",
    "about.visionTitle": "Our Vision",
    "about.visionText": "To be a leading brand in the terry textile industry by delivering products that combine premium quality, distinctive design, and ultimate comfort, while building a brand trusted by our customers locally and globally.",
    "about.goalsEyebrow": "Strategic Direction",
    "about.goalsTitle": "Our Goals",
    "about.goalsSubtitle": "Strategic pillars that translate our vision into tangible reality and exacting standards at every step of our craft.",
    "about.goal1Title": "Quality First",
    "about.goal1Desc": "Delivering products built to exacting quality standards, from the careful selection of raw materials to the finest manufacturing details.",
    "about.goal2Title": "Customer Satisfaction",
    "about.goal2Desc": "Deeply understanding our customers' needs to deliver products and experiences that consistently surpass expectations.",
    "about.goal3Title": "Innovation & Development",
    "about.goal3Desc": "Developing contemporary designs and innovative products that keep pace with market trends and evolving customer tastes.",
    "about.goal4Title": "Sustainability",
    "about.goal4Desc": "Continuously optimizing production processes, minimizing waste, and ensuring the responsible stewardship of natural resources.",
    "about.goal5Title": "Strategic Expansion",
    "about.goal5Desc": "Broadening our market presence across domestic and international markets while cultivating enduring partnerships.",
    "about.goal6Title": "Building a Trusted Brand",
    "about.goal6Desc": "Solidifying our reputation as a hallmark of trust, uncompromised quality, and meticulous attention to detail.",
    "about.statsEyebrow": "Milestones in Numbers",
    "about.statsTitle": "Trust Crafted Stitch by Stitch",
    "about.stat1Value": "100%",
    "about.stat1Label":"Quality Assurance",
    "about.stat2Value": "50k+",
    "about.stat2Label": "Satisfied Customers Nationwide",
    "about.stat3Value": "25+ Yrs",
    "about.stat3Label": "Textile Weaving & Spinning Mastery",
    "about.stat4Value": "4.9 ★",
    "about.stat4Label": "Average Customer Satisfaction Rating",
    "about.craftEyebrow": "Anatomy of Quality",
    "about.craftTitle": "How We Craft the Difference",
    "about.craftSubtitle": "Meticulous attention to technical details to achieve the golden balance of plush volume, quick drying, and featherlight touch.",
    "about.craft1Title": "Calibrated GSM Density",
    "about.craft1Desc": "Carefully balanced grammage provides instant moisture wicking and cozy warmth without feeling cumbersome in the laundry.",
    "about.craft2Title": "Combed Ring-Spun Terry Loops",
    "about.craft2Desc": "Precision combing removes short fibers and impurities, virtually eliminating lint shedding and providing a cloud-like texture.",
    "about.craft3Title": "Hypoallergenic & Skin-Kind",
    "about.craft3Desc": "Tested free of harsh irritants and gentle enough for sensitive skin, infants, and those who demand uncompromised textile purity.",
    "about.ctaTitle": "Ready to Experience Terry Land Luxury at Home?",
    "about.ctaSub": "Explore our curated collections of bathrobes, bath sheets, and luxury linen sets, or reach out to our team for sizing guidance.",
    "about.ctaShop": "Explore Collections",
    "about.ctaContact": "Contact Our Concierge",

    // ── Contact Page ──
    "contact.metaTitle": "Contact Us | Terry Land Luxury Concierge",
    "contact.breadcrumbHome": "Home",
    "contact.breadcrumbCurrent": "Contact Us",
    "contact.heroBadge": "Luxury Concierge",
    "contact.heroTitle": "We Are Here to Assist You",
    "contact.heroSubtitle": "Whether you have questions about sizing, tracking your order with Bosta, or coordinating bespoke corporate gifting, our concierge team is always delighted to assist.",
    "contact.whatsappTitle": "WhatsApp Concierge",
    "contact.whatsappDesc": "Instant assistance & personalized sizing guidance",
    "contact.whatsappAction": "Chat with Us on WhatsApp",
    "contact.whatsappNumber": "+20 10 9992 1862",
    "contact.emailTitle": "Customer Care Email",
    "contact.emailVal": "info@terryland.net",
    "contact.phoneTitle": "Direct Telephone",
    "contact.phoneVal": "+20 10 9992 1862",
    "contact.hoursTitle": "Operating Hours",
    "contact.hoursVal": "Sat – Thu: 9:00 AM – 9:00 PM (Cairo Time)",
    "contact.locationTitle": "Headquarters",
    "contact.locationVal": "Street 400, Obour, Al-Qalyubia Governorate, Cairo, Egypt",
    "contact.faqPrompt": "Looking for quick answers regarding shipping or returns?",
    "contact.faqLink": "Browse Frequently Asked Questions",
    "contact.formTitle": "Send Us a Message",
    "contact.formSubtitle": "Complete the form below and a concierge specialist will respond within a few business hours.",
    "contact.subjectLabel": "Inquiry Subject",
    "contact.subjOrder": "Order Status",
    "contact.subjSize": "Sizing & Fabrics",
    "contact.subjWholesale": "Corporate & Wholesale",
    "contact.subjGeneral": "General Inquiry",
    "contact.nameLabel": "Full Name",
    "contact.namePlaceholder": "e.g. John Doe",
    "contact.emailLabel": "Email Address",
    "contact.emailPlaceholder": "name@example.com",
    "contact.phoneLabel": "Mobile Phone (Optional)",
    "contact.phonePlaceholder": "010 1234 5678",
    "contact.msgLabel": "Your Message",
    "contact.msgPlaceholder": "How can our concierge team assist you today?",
    "contact.charCount": "{count}/500 chars",
    "contact.btnSend": "Send Message",
    "contact.sending": "Sending Message…",
    "contact.successTitle": "Message Received Successfully!",
    "contact.successDesc": "Thank you for contacting Terry Land. Your message has been routed to our concierge team and we will be in touch shortly.",
    "contact.sendAnother": "Send Another Message",
    "contact.errName": "Please enter your name.",
    "contact.errEmail": "Please enter a valid email address.",
    "contact.errMsg": "Please enter your message (at least 10 characters).",
    "contact.toastSuccess": "Message sent successfully! We will get back to you shortly.",

    // ── FAQ Page ──
    "faq.metaTitle": "FAQ | Microfiber, Cotton, Sizing & Bridal Linens — Terry Land",
    "faq.eyebrow": "Help & Support Concierge",
    "faq.title": "Frequently Asked Questions",
    "faq.subtitle": "Comprehensive answers about our microfiber and cotton fabrics, sizing for bathrobes, towels, bridal sets, and textile care.",
    "faq.searchPlaceholder": "Search questions (e.g., shipping, washing, sizing, bridal)...",
    "faq.searchAria": "Search frequently asked questions",
    "faq.clearSearch": "Clear search",
    "faq.resultsCount": "Found {count} matching questions",
    "faq.noResultsTitle": "No matching questions found",
    "faq.noResultsDesc": "We couldn't find an answer matching your query. Try different keywords or contact our concierge directly.",
    "faq.resetSearch": "Reset Search",
    "faq.catAll": "All",
    "faq.catOrders": "Orders & Shipping",
    "faq.catCotton": "Fabrics & Quality",
    "faq.catSizing": "Sizing & Fit",
    "faq.catCare": "Care & Washing",
    "faq.catReturns": "Returns & Warranty",
    "faq.conciergeTitle": "Need immediate assistance?",
    "faq.conciergeSub": "Our Terry Land concierge team is always delighted to assist with any bespoke request.",
    "faq.trackOrder": "Track My Order",
    "faq.trackOrderDesc": "Check your delivery status and real-time updates",
    "faq.careGuide": "Textile Care Guide",
    "faq.careGuideDesc": "Expert guidelines for lasting plushness and absorbency",
    "faq.waConcierge": "Direct WhatsApp Concierge",
    "faq.waConciergeDesc": "Chat instantly with our customer care specialists",
    "faq.stillHaveQuestions": "Didn't find what you are looking for?",
    "faq.contactCta": "Contact Our Concierge",

    // ── Blog / Journal Page ──
    "blog.metaTitle": "The Terry Land Journal | Bridal Linens, Robes, Towels & Bedding Guides",
    "blog.eyebrow": "The Terry Land Journal",
    "blog.title": "The Terry Land Journal: Fine Linens & Newlywed Living",
    "blog.subtitle": "Explore fine textiles, essential bridal registry checklists, and expert comparisons between cotton, microfiber, and our breakthrough dual-face weaves.",
    "blog.featuredBadge": "Featured Story",
    "blog.readStory": "Read Full Story",
    "blog.readTime": "{minutes} min read",
    "blog.publishedOn": "Published",
    "blog.author": "By",
    "blog.atelierAuthor": "Terry Land Team",
    "blog.catAll": "All Stories",
    "blog.catHeritage": "Heritage & Craft",
    "blog.catRituals": "Bath & Living Rituals",
    "blog.catGuides": "Fabric Guides",
    "blog.catCare": "Care Masterclass",
    "blog.catInteriors": "Interiors & Hospitality",
    "blog.shareStory": "Share Story",
    "blog.copiedToast": "Story link copied to clipboard!",
    "blog.closeReader": "Close Reader",
    "blog.keyTakeaways": "Key Takeaways & Highlights:",
    "blog.shopRecommended": "Recommended in this Story:",
    "blog.exploreCollection": "Explore Collection",
    "blog.newsletterTitle": "Join The Terry Land Circle",
    "blog.newsletterSub": "Receive seasonal editorial stories and private invitations to preview new luxury collections.",
    "blog.newsletterPlaceholder": "Enter your email address...",
    "blog.newsletterSubscribe": "Subscribe",
    "blog.newsletterSuccess": "Thank you for joining the Terry Land Journal!",

    // ── Thanks / Order Confirmation ──
    "thanks.title": "Thank You for Your Order!",
    "thanks.subtitle": "Your order has been received and confirmed. We are carefully preparing your items for delivery.",
    "thanks.orderNumber": "Order Reference:",
    "thanks.copy": "Copy",
    "thanks.copied": "Copied!",
    "thanks.deliveryEstimate": "Estimated Delivery",
    "thanks.deliveryEstimateDays": "Within 2 to 4 business days",
    "thanks.deliveryCourier": "Shipped directly to your doorstep via Bosta",
    "thanks.timelineTitle": "Order Progress",
    "thanks.step1": "Order Confirmed",
    "thanks.step1Desc": "Received and validated",
    "thanks.step2": "Preparing & Packing",
    "thanks.step2Desc": "Quality check and luxury packaging",
    "thanks.step3": "Out for Delivery",
    "thanks.step3Desc": "On its way to your address",
    "thanks.step4": "Delivered",
    "thanks.step4Desc": "Enjoy your luxury textiles",
    "thanks.paymentMethod": "Payment Method",
    "thanks.paymentCod": "Cash on Delivery",
    "thanks.paymentCard": "Paid Online via Card",
    "thanks.orderSummary": "Order Summary",
    "thanks.itemsCount": "{count} items",
    "thanks.totalAmount": "Total Amount:",
    "thanks.shippingTo": "Shipping to:",
    "thanks.viewOrder": "View Order Details",
    "thanks.viewAllOrders": "My Orders",
    "thanks.continueShopping": "Continue Shopping",
    "thanks.needHelp": "Have questions about your order?",
    "thanks.contactSupport": "Contact Customer Support",
    "thanks.metaTitle": "Thank You for Your Order | TERRY LAND",

    // ── 404 Not Found Page ──
    "notFound.metaTitle": "404 - Page Not Found | TERRY LAND",
    "notFound.eyebrow": "Error 404 • Page Not Found",
    "notFound.code": "404",
    "notFound.title": "We Couldn't Find the Page You're Looking For",
    "notFound.desc": "The page you requested might have been moved, renamed, or is temporarily unavailable. Return to our homepage or discover our handcrafted luxury collections below.",
    "notFound.backHome": "Return to Homepage",
    "notFound.exploreShop": "Explore All Collections",
    "notFound.quickLinksTitle": "Popular destinations you might be looking for:",
    "notFound.linkBathrobes": "Luxury Bathrobes",
    "notFound.linkBathrobesDesc": "Signature 100% cotton, plush microfiber & dual-face weaves",
    "notFound.linkTowels": "Hotel Towels & Bath Sheets",
    "notFound.linkTowelsDesc": "Superior absorbency & cloud-soft texture in all sizes",
    "notFound.linkAbout": "Our Atelier & Heritage",
    "notFound.linkAboutDesc": "Master textile craftsmanship & Egyptian heritage since 1956",
    "notFound.linkContact": "Contact Atelier Concierge",
    "notFound.linkContactDesc": "Our advisors are ready to assist with sizing & orders",
    "notFound.helpNote": "Need immediate assistance or looking for a specific item?",
    "notFound.whatsappChat": "Chat With Us on WhatsApp",

    // ── System & API Error Messages (English) ──
    "errors.GENERIC_ERROR": "An unexpected error occurred. Please try again later.",
    "errors.INTERNAL_SERVER_ERROR": "A server error occurred. Please try again later.",
    "errors.NETWORK_ERROR": "Unable to connect to the server. Please check your internet connection.",
    "errors.BAD_REQUEST": "Invalid request. Please check the provided information.",
    "errors.VALIDATION_FAILED": "Please check the entered data for errors and try again.",
    "errors.RESOURCE_NOT_FOUND": "The requested item was not found.",
    "errors.ALREADY_EXISTS": "This record already exists.",
    "errors.DOMAIN_RULE_VIOLATION": "Unable to complete request under current conditions.",
    "errors.EXTERNAL_SERVICE_ERROR": "An error occurred connecting to external service, please try again.",

    // Auth & Identity
    "errors.AUTH_INVALID_CREDENTIALS": "Username or password is incorrect.",
    "errors.AUTH_EMAIL_ALREADY_IN_USE": "This email is already registered.",
    "errors.AUTH_EMAIL_NOT_CONFIRMED": "Please confirm your email before signing in.",
    "errors.AUTH_EMAIL_VERIFICATION_PENDING": "A verification link has been sent to your email. Please check your inbox.",
    "errors.AUTH_EMAIL_VERIFICATION_THROTTLED": "A verification email was recently sent. Please wait a minute before requesting another.",
    "errors.AUTH_INCOMPLETE_CREDENTIALS": "Please enter both email and password.",
    "errors.AUTH_INVALID_TOKEN": "Invalid or expired verification token.",
    "errors.USER_NOT_FOUND": "User not found. Please sign in.",
    "errors.UNAUTHORIZED": "Please sign in to continue.",
    "errors.FORBIDDEN": "You do not have permission to perform this action.",

    // Cart & Products
    "errors.CART_EMPTY": "Your cart is currently empty.",
    "errors.CART_MAX_QUANTITY_REACHED": "Maximum 10 items allowed for this product.",
    "errors.CART_INVALID_QUANTITY": "Quantity cannot be zero.",
    "errors.CART_ITEM_NOT_FOUND": "Item not found in cart.",
    "errors.PRODUCT_UNAVAILABLE": "This product is currently unavailable.",
    "errors.PRODUCT_NOT_FOUND": "Product not found.",
    "errors.INVALID_VARIANT": "Selected color and size combination is unavailable.",
    "errors.OUT_OF_STOCK": "This product is out of stock.",

    // Shipping & Addresses
    "errors.SHIPPING_ADDRESS_UNREACHABLE": "We cannot deliver to this address at the moment. Please select another address.",
    "errors.SHIPPING_INVALID_CITY_DISTRICT": "Selected city and district combination is invalid.",
    "errors.SHIPPING_ADDRESS_INVALID": "Shipping address information is invalid.",
    "errors.ADDRESS_NOT_FOUND": "Address not found.",

    // Orders & Checkout
    "errors.ORDER_PACKAGE_LIMIT_EXCEEDED": "Your order exceeds the permitted package size. Please reduce the number of items.",
    "errors.ORDER_NOT_FOUND": "Order not found.",
    "errors.ORDER_CANNOT_CANCEL": "This order cannot be cancelled in its current state.",
    "errors.ORDER_ALREADY_CANCELLED": "This order is already cancelled.",
    "errors.ORDER_CANNOT_REPAY": "This order cannot be repaid.",
    "errors.ORDER_REFUND_LIMIT_EXCEEDED": "Refund amount exceeds total order amount.",
    "errors.ORDER_REFUND_PERIOD_EXPIRED": "Cannot refund item after 10 days from purchase.",
    "errors.COUPON_INVALID": "Invalid coupon code.",
    "errors.COUPON_EXPIRED": "This coupon code has expired.",
    "errors.COUPON_MIN_SPEND_NOT_MET": "Order total does not meet the minimum amount for this coupon.",
    "errors.COUPON_USAGE_LIMIT_EXCEEDED": "This coupon has reached its maximum usage limit.",
  },
};
